{
  "translation": {
    "allocations": {
      "actions": {
        "assign": "Assign"
      },
      "errors": {
        "deleting": "Error encountered while deleting allocation. {{message}}",
        "saving": "Error while allocating.  {{message}}",
        "validation": "Please ensure all fields are entered correctly.  "
      },
      "fields": {
        "employee": "Allocated To"
      },
      "successes": {
        "deleted": "Allocation deleted successfully.",
        "save": "Allocated successfully. "
      }
    },
    "appointments": {
      "actions": {
        "block": "Block Day",
        "calculate": "Calculate SMART Dates",
        "cancel": "Cancel Appointment",
        "intake": "Intake",
        "new": "New Appointment",
        "preview": "Preview",
        "reschedule": "Reschedule",
        "sendreminder": "Send Reminder",
        "unblock": "Unblock",
        "viewjob": "View Job"
      },
      "errors": {
        "blocking": "Error creating block {{message}}.",
        "canceling": "Error canceling appointment. {{message}}",
        "saving": "Error scheduling appointment. {{message}}"
      },
      "fields": {
        "alt_transport": "Alt. Trans.",
        "color": "Appointment Color",
        "end": "End",
        "note": "Note",
        "start": "Start",
        "time": "Appointment Time",
        "title": "Title"
      },
      "labels": {
        "arrivedon": "Arrived on: ",
        "arrivingjobs": "Arriving Jobs",
        "blocked": "Blocked",
        "bp": "B/P",
        "cancelledappointment": "Canceled appointment for: ",
        "completingjobs": "Completing Jobs",
        "dataconsistency": "<0>{{ro_number}}</0> has a data consistency issue. It may have been excluded for scheduling purposes. CODE: {{code}}.",
        "expectedjobs": "Expected Jobs in Production: ",
        "expectedprodhrs": "Expected Production Hours:",
        "history": "History",
        "inproduction": "Jobs In Production",
        "manualevent": "Add Manual Appointment",
        "noarrivingjobs": "No Jobs are arriving.",
        "nocompletingjobs": "No Jobs scheduled for completion.",
        "nodateselected": "No date has been selected.",
        "owner": "Owner",
        "priorappointments": "Previous Appointments",
        "reminder": "This is {{shopname}} reminding you about an appointment on {{date}} at {{time}}. Please let us know if you are not able to make the appointment. We look forward to seeing you soon. ",
        "ro_number": "RO #",
        "scheduled_completion": "Scheduled Completion",
        "scheduledfor": "Scheduled appointment for: ",
        "severalerrorsfound": "Several Jobs have issues which may prevent accurate smart scheduling. Click to expand.",
        "smartscheduling": "Smart Scheduling",
        "smspaymentreminder": "This is {{shopname}} reminding you about your remaining balance of {{amount}}. To pay for the said balance click the link {{payment_link}}.",
        "suggesteddates": "Suggested Dates",
        "vehicle": "Vehicle"
      },
      "successes": {
        "canceled": "Appointment canceled successfully.",
        "created": "Appointment scheduled successfully.",
        "saved": "Appointment saved successfully."
      }
    },
    "associations": {
      "actions": {
        "activate": "Activate"
      },
      "fields": {
        "active": "Active?",
        "shopname": "Shop Name"
      },
      "labels": {
        "actions": "Actions"
      }
    },
    "audio": {
      "manager": {
        "description": "Click anywhere to enable the message ding."
      }
    },
    "audit": {
      "fields": {
        "cc": "CC",
        "contents": "Contents",
        "created": "Time",
        "operation": "Operation",
        "status": "Status",
        "subject": "Subject",
        "to": "To",
        "useremail": "User",
        "values": "Values"
      }
    },
    "audit_trail": {
      "messages": {
        "admin_job_remove_from_ar": "ADMIN: Remove from AR updated to: {{status}}",
        "admin_jobmarkexported": "ADMIN: Job marked as exported.",
        "admin_jobmarkforreexport": "ADMIN: Job marked for re-export.",
        "admin_jobuninvoice": "ADMIN: Job has been uninvoiced.",
        "admin_jobunvoid": "ADMIN: Job has been unvoided.",
        "alerttoggle": "Alert Toggle set to {{status}}",
        "appointmentcancel": "Appointment canceled. Lost Reason: {{lost_sale_reason}}.",
        "appointmentinsert": "Appointment created. Appointment Date: {{start}}.",
        "assignedlinehours": "Assigned job lines totaling {{hours}} units to {{team}}.",
        "billdeleted": "Bill with invoice number {{invoice_number}} deleted.",
        "billmarkforreexport": "Bill with invoice number {{invoice_number}} marked for re-export.",
        "billposted": "Bill with invoice number {{invoice_number}} posted.",
        "billupdated": "Bill with invoice number {{invoice_number}} updated with the following details: {{details}}.",
        "failedpayment": "Failed payment attempt.",
        "jobassignmentchange": "Employee {{name}} assigned to {{operation}}",
        "jobassignmentremoved": "Employee assignment removed for {{operation}}",
        "jobchecklist": "Checklist type \"{{type}}\" completed.  In production set to {{inproduction}}.  Status set to {{status}}.",
        "jobclosedwithbypass": "Job was invoiced using the master bypass password. ",
        "jobconverted": "Job converted and assigned number {{ro_number}}.",
        "jobdelivery": "Job intake completed. Status set to {{status}}. Actual completion is {{actual_completion}}.",
        "jobexported": "Job has been exported",
        "jobfieldchanged": "Job field $t(jobs.fields.{{field}}) changed to {{value}}.",
        "jobimported": "Job imported.",
        "jobinproductionchange": "Job production status set to {{inproduction}}",
        "jobintake": "Job intake completed. Status set to {{status}}. Scheduled completion is {{scheduled_completion}}.",
        "jobinvoiced": "Job has been invoiced.",
        "jobioucreated": "IOU Created.",
        "joblineupdate": "Job line {{lineDescription}} updated with the following details: {{details}}.",
        "jobmanualcreate": "Job manually created.",
        "jobmanuallineinsert": "Job line manually added with the following details: {{details}}.",
        "jobmodifylbradj": "Labor adjustments modified {{mod_lbr_ty}} / {{hours}}.",
        "jobnoteadded": "Note added to Job.",
        "jobnotedeleted": "Note deleted from Job.",
        "jobnoteupdated": "Note updated on Job.",
        "jobspartsorder": "Parts order {{order_number}} added to Job.",
        "jobspartsreturn": "Parts return {{order_number}} added to Job.",
        "jobstatuschange": "Job status changed to {{status}}.",
        "jobsupplement": "Job supplement imported.",
        "jobsuspend": "Suspend Toggle set to {{status}}",
        "jobvoid": "Job has been voided.",
        "paymententered": "Payment {{paymentnum}} entered.",
        "paymentupdated": "Payment {{paymentnum}} updated.",
        "tasks_completed": "Task '{{title}}' completed by {{completedBy}}",
        "tasks_created": "Task '{{title}}' created by {{createdBy}}",
        "tasks_deleted": "Task '{{title}}' deleted by {{deletedBy}}",
        "tasks_uncompleted": "Task '{{title}}' uncompleted by {{uncompletedBy}}",
        "tasks_undeleted": "Task '{{title}}' undeleted by {{undeletedBy}}",
        "tasks_updated": "Task '{{title}}' updated by {{updatedBy}}",
        "techjobstatuschange": "Tech Console changed Job status to {{status}}.",
        "timeticketcreated": "Time Ticket for {{employee}} on {{date}} created with the following details: {{details}}.",
        "timeticketpayall": "All Time Tickets for Job have been paid using Ticket Date {{date}}.",
        "timeticketupdated": "Time Ticket for {{employee}} on {{date}} updated with the following details: {{details}}"
      }
    },
    "billlines": {
      "actions": {
        "newline": "New Line"
      },
      "fields": {
        "actual_cost": "Actual Cost",
        "actual_price": "Retail",
        "confidence": "Confidence",
        "cost_center": "Cost Center",
        "federal_tax_applicable": "Fed. Tax?",
        "jobline": "Job Line",
        "line_desc": "Line Description",
        "local_tax_applicable": "Loc. Tax?",
        "location": "Location",
        "oem_partno": "Part #",
        "quantity": "Quantity",
        "state_tax_applicable": "St. Tax?"
      },
      "labels": {
        "deductedfromlbr": "Deduct from Labor?",
        "entered": "Entered",
        "from": "From",
        "mod_lbr_adjustment": "Adjustment Units",
        "other": "-- Not On Estimate --",
        "reconciled": "Reconciled!",
        "unreconciled": "Unreconciled"
      },
      "validation": {
        "atleastone": "At least one bill line must be entered."
      }
    },
    "bills": {
      "actions": {
        "deductallhours": "Deduct all",
        "edit": "Edit",
        "receive": "Receive Part",
        "return": "Return Items"
      },
      "errors": {
        "calculating_totals": "Error Calculating Totals",
        "calculating_totals_generic": "Please ensure all fields are properly completed. ",
        "creating": "Error adding bill.  {{error}}",
        "deleting": "Error deleting bill. {{error}}",
        "existinginventoryline": "This bill cannot be deleted as it is tied to items in inventory.",
        "exporting": "Error exporting payable(s). {{error}}",
        "exporting-partner": "Unable to connect to partner application. Please ensure it is running and logged in.",
        "invalidro": "Not a valid RO.",
        "invalidvendor": "Not a valid vendor.",
        "validation": "Please ensure all fields are entered correctly. "
      },
      "fields": {
        "allpartslocation": "Parts Bin",
        "date": "Bill Date",
        "exported": "Exported",
        "federal_tax_rate": "Federal Tax Rate",
        "invoice_number": "Invoice Number",
        "is_credit_memo": "Credit Memo?",
        "is_credit_memo_short": "CM",
        "local_tax_rate": "Local Tax Rate",
        "ro_number": "RO Number",
        "state_tax_rate": "State Tax Rate",
        "total": "Bill Total",
        "vendor": "Vendor",
        "vendorname": "Vendor Name"
      },
      "labels": {
        "actions": "Actions",
        "ai": {
          "accept_and_continue": "Accept and Continue",
          "confidence": {
            "breakdown": "Confidence Breakdown",
            "match": "Jobline Match",
            "missing_data": "Missing Data",
            "ocr": "Optical Character Recognition",
            "overall": "Overall"
          },
          "disclaimer_title": "AI Scan Beta Disclaimer",
          "feedback_placeholder": "Tell us what worked,  what didn't, and what could be better.",
          "feedback_prompt": "Was this AI scan helpful?",
          "generic_failure": "Failed to process invoice.",
          "multipage": "The is a multi-page document.  Processing will take a few moments.",
          "processing": "Analyzing Bill",
          "scan": "AI Bill Scanner",
          "scancomplete": "AI Scan Complete",
          "scanfailed": "AI Scan Failed",
          "scanstarted": "AI Scan Started",
          "submit_feedback": "Submit Feedback"
        },
        "bill_lines": "Bill Lines",
        "bill_total": "Bill Total Amount",
        "billcmtotal": "Credit Memos",
        "bills": "Bills",
        "calculatedcreditsnotreceived": "Calculated CNR",
        "creditsnotreceived": "Credits Not Marked Received",
        "creditsreceived": "Credits Received",
        "dedfromlbr": "Labor Adjustments",
        "deleteconfirm": "Are you sure you want to delete this bill? It cannot be undone. If this bill has deductions from labors, manual changes may be required.",
        "discrepancy": "Discrepancy",
        "discrepwithcms": "Discrepancy including Credit Memos",
        "discrepwithlbradj": "Discrepancy including Lbr.  Adj.",
        "editadjwarning": "This bill had lines which resulted in labor adjustments. Manual correction to adjustments may be required.",
        "entered_total": "Total of Entered Lines",
        "enteringcreditmemo": "You are entering a credit memo. Please ensure you are also entering positive values.",
        "federal_tax": "Federal Tax",
        "federal_tax_exempt": "Federal Tax Exempt?",
        "generatepartslabel": "Generate Parts Labels after Saving?",
        "iouexists": "An IOU exists that is associated to this RO.",
        "local_tax": "Local Tax",
        "markexported": "Mark Exported",
        "markforreexport": "Mark for Re-export",
        "new": "New Bill",
        "nobilllines": "No bills have been posted yet.",
        "noneselected": "No bill selected.",
        "onlycmforinvoiced": "Only credit memos can be entered for any Job that has been invoiced, exported, or voided.",
        "printlabels": "Print Labels",
        "retailtotal": "Bills Retail Total",
        "returnfrombill": "Return From Bill",
        "savewithdiscrepancy": "You are about to save this bill with a discrepancy.  The system will continue to use the calculated amount using the bill lines.  Press cancel to return to the bill.",
        "state_tax": "State Tax",
        "subtotal": "Subtotal",
        "totalreturns": "Total Returns"
      },
      "successes": {
        "created": "Invoice added successfully.",
        "deleted": "Bill deleted successfully.",
        "exported": "Bill(s) exported successfully.",
        "markexported": "Bill marked as exported.",
        "reexport": "Bill marked for re-export."
      },
      "validation": {
        "closingperiod": "This Bill Date is outside of the Closing Period.",
        "inventoryquantity": "Quantity must be greater than or equal to what has been added to inventory ({{number}}).",
        "manualinhouse": "Manual posting to the in house vendor is restricted. ",
        "unique_invoice_number": "This invoice number has already been entered for this vendor."
      }
    },
    "bodyshop": {
      "actions": {
        "add_adjuster": "Add Adjuster",
        "add_control_number": "Add Control Number",
        "add_cost_center": "Add Cost Center",
        "add_courtesy_car_rate_preset": "Add Courtesy Car Contract Rate Preset",
        "add_delivery_checklist_item": "Add Delivery Checklist Item",
        "add_dms_allocation": "Add DMS Allocation",
        "add_estimator": "Add Estimator",
        "add_insurance_company": "Add Insurance Company",
        "add_intake_checklist_item": "Add Intake Checklist Item",
        "add_jobline_preset": "Add Jobline Preset",
        "add_messaging_preset": "Add Messaging Preset",
        "add_note_preset": "Add Note Preset",
        "add_parts_order_comment": "Add Parts Order Comment",
        "add_production_status_color": "Add Production Status Color",
        "add_profit_center": "Add Profit Center",
        "add_task_preset": "Add Task Preset",
        "add_to_email_preset": "Add To Email Preset",
        "addapptcolor": "Add Appointment Color",
        "addbucket": "Add Definition",
        "addpartslocation": "Add Parts Location",
        "addpartsrule": "Add Parts Scan Rule",
        "addspeedprint": "Add Speed Print",
        "addtemplate": "Add Template",
        "newlaborrate": "New Labor Rate",
        "newsalestaxcode": "New Sales Tax Code",
        "newstatus": "Add Status",
        "save_shop_information": "Save Shop Information",
        "testrender": "Test Render"
      },
      "errors": {
        "creatingdefaultview": "Error creating default view.",
        "duplicate_insurance_company": "Duplicate insurance company name. Each insurance company name must be unique",
        "duplicate_job_status": "Duplicate job status. Each job status must be unique.",
        "loading": "Unable to load shop details. Please call technical support.",
        "media_tag_in_use": "The tag '{{tag}}' is assigned to one or more files and cannot be removed.",
        "media_tag_reserved": "'{{tag}}' is reserved for media storage and cannot be used as a tag. Reserved names: {{reservedTags}}.",
        "media_tag_usage_loading": "Tag usage is still being checked. Wait for the check to finish before removing an existing tag.",
        "media_tag_usage_unavailable": "Tag usage could not be checked. Existing tags cannot be removed until the media provider is available.",
        "saving": "Error encountered while saving. {{message}}",
        "task_preset_allocation_exceeded": "{{laborType}} task preset total is {{total}}% and cannot exceed 100%."
      },
      "fields": {
        "ReceivableCustomField": "QBO Receivable Custom Field {{number}}",
        "accumulatePayableLines": "Accumulate Payable Lines",
        "address1": "Address 1",
        "address2": "Address 2",
        "appt_alt_transport": "Appointment Alternative Transportation Options",
        "appt_colors": {
          "color": "Color",
          "label": "Label"
        },
        "appt_length": "Default Appointment Length",
        "attach_pdf_to_email": "Attach PDF copy to sent emails?",
        "batchid": "ADP Batch ID",
        "bill_allow_post_to_closed": "Allow Bills to be posted to Closed Jobs",
        "bill_federal_tax_rate": "Bills - Federal Tax Rate %",
        "bill_local_tax_rate": "Bill - Local Tax Rate %",
        "bill_state_tax_rate": "Bill - Provincial/State Tax Rate %",
        "city": "City",
        "closingperiod": "Closing Period",
        "companycode": "ADP Company Code",
        "country": "Country",
        "dailybodytarget": "Scoreboard - Daily Body Target",
        "dailypainttarget": "Scoreboard - Daily Paint Target",
        "default": "Default",
        "default_adjustment_rate": "Default Labor Deduction Adjustment Rate",
        "deliver": {
          "require_actual_delivery_date": "Require Actual Delivery",
          "templates": "Delivery Templates"
        },
        "disableBillCostCalculation": "Disable Automatic Bill Cost Calculation",
        "dms": {
          "apcontrol": "AP Control Number",
          "appostingaccount": "AP Posting Account",
          "cashierid": "Cashier ID",
          "default_journal": "Default Journal",
          "disablebillwip": "Disable bill WIP for A/P Posting",
          "disablecontact": "Disable Contact Updates/Creation",
          "disablecontactvehiclecreation": "Disable Contact & Vehicle Updates/Creation",
          "dms_acctnumber": "DMS Account #",
          "dms_control_override": "Static Control # Override",
          "dms_wip_acctnumber": "DMS W.I.P.  Account #",
          "generic_customer_number": "Generic Customer Number",
          "itc_federal": "Federal Tax is ITC?",
          "itc_local": "Local Tax is ITC?",
          "itc_state": "State Tax is ITC?",
          "mappingname": "DMS Mapping Name",
          "ro_posting": "Create $0 RO?",
          "sendmaterialscosting": "Materials Cost as % of Sale",
          "srcco": "Source Company #/Dealer #"
        },
        "email": "General Shop Email",
        "enforce_class": "Enforce Class on Conversion?",
        "enforce_conversion_category": "Enforce Category on Conversion?",
        "enforce_conversion_csr": "Enforce CSR on Conversion?",
        "enforce_referral": "Enforce Referrals on Conversion?",
        "enforce_registration_number": "Enforce Registration Number on Conversion?",
        "federal_tax_id": "Federal Tax ID (GST/HST)",
        "ignoreblockeddays": "Scoreboard - Ignore Blocked Days",
        "inhousevendorid": "In House Vendor ID",
        "insurance_vendor_id": "Insurance Vendor ID",
        "intake": {
          "next_contact_hours": "Automatic Next Contact Date - Hours from Intake",
          "templates": "Intake Templates"
        },
        "intellipay_config": {
          "cash_discount_percentage": "Cash Discount %",
          "enable_cash_discount": "Enable Cash Discounting",
          "payment_map": {
            "amex": "American Express",
            "disc": "Discover",
            "dnrs": "Diners",
            "intr": "Interac",
            "jcb": "JCB",
            "mast": "MasterCard",
            "visa": "Visa"
          },
          "payment_type": "Payment Type Map"
        },
        "invoice_federal_tax_rate": "Invoices - Federal Tax Rate",
        "invoice_local_tax_rate": "Invoices - Local Tax Rate",
        "invoice_state_tax_rate": "Invoices - State Tax Rate",
        "jc_hourly_rates": {
          "mapa": "Job Costing - Paint Materials Hourly Cost Rate",
          "mash": "Job Costing - Shop Materials Hourly Cost Rate"
        },
        "last_name_first": "Display Owner Info as <Last>, <First>",
        "lastnumberworkingdays": "Scoreboard - Last Number of Working Days",
        "localmediaserverhttp": "Local Media Server - HTTP Path",
        "localmediaservernetwork": "Local Media Server - Network Path",
        "localmediatoken": "Local Media Server - Token",
        "logo_img_footer_margin": "Footer Margin (px)",
        "logo_img_header_margin": "Header Margin (px)",
        "logo_img_path": "Shop Logo",
        "logo_img_path_height": "Logo Image Height",
        "logo_img_path_width": "Logo Image Width",
        "md_categories": "Categories",
        "md_ccc_rates": "Courtesy Car Contract Rate Presets",
        "md_classes": "Classes",
        "md_ded_notes": "Deductible Notes",
        "md_email_cc": "Auto Email CC: $t(parts_orders.labels.{{template}})",
        "md_from_emails": "Additional From Emails",
        "md_functionality_toggles": {
          "enhanced_early_ros": "Enable Enhance Early ROs",
          "parts_queue_toggle": "Auto Add Imported/Supplemented Jobs to Parts Queue"
        },
        "md_hour_split": {
          "paint": "Paint Hour Split",
          "prep": "Prep Hour Split"
        },
        "md_ins_co": {
          "city": "City",
          "name": "Insurance Company Name",
          "private": "Private",
          "state": "Province/State",
          "street1": "Street 1",
          "street2": "Street 2",
          "zip": "Zip/Postal Code"
        },
        "md_jobline_presets": "Jobline Presets",
        "md_lost_sale_reasons": "Lost Sale Reasons",
        "md_parts_order_comment": "Parts Orders Comments",
        "md_parts_scan": {
          "caseInsensitive": "Case Insensitive",
          "expression": "",
          "field": "Field",
          "flags": "",
          "mark_critical": "Mark Line as Critical?",
          "operation": "Operation",
          "update_field": "Field to Update",
          "update_value": "Update Value",
          "value": "Value"
        },
        "md_payment_types": "Payment Types",
        "md_referral_sources": "Referral Sources",
        "md_ro_guard": {
          "enabled": "RO Guard Enabled?",
          "enforce_ar": "Enforce AR Balance",
          "enforce_bills": "Enforce Bill Discrepancy",
          "enforce_cm": "Enforce Credit Memo Entry",
          "enforce_labor": "Enforce Labor Allocation",
          "enforce_ppd": "Enforce PPD Sync",
          "enforce_profit": "Enforce Profit Requirement",
          "enforce_sublet": "Enforce Sublet Completion",
          "masterbypass": "Master Bypass Password (not encrypted)",
          "totalgppercent_minimum": "Minimum Total Gross Profit %"
        },
        "md_tasks_presets": {
          "enable_tasks": "Enable Hour Flagging",
          "hourstype": "Hour Types",
          "memo": "Time Ticket Memo",
          "name": "Preset Name",
          "nextstatus": "Next Status",
          "percent": "Percent",
          "use_approvals": "Use Time Ticket Approval Queue"
        },
        "messaginglabel": "Messaging Preset Label",
        "messaginglabel_short": "Label",
        "messagingtext": "Messaging Preset Text",
        "messagingtext_short": "Text",
        "noteslabel": "Note Label",
        "noteslabel_short": "Label",
        "notestext": "Note Text",
        "notestext_short": "Text",
        "notifications": {
          "description": "Select employees to automatically follow new jobs and receive notifications for job updates.",
          "invalid_followers": "Invalid selection. Please select valid employees.",
          "placeholder": "Search for employees"
        },
        "partslocation": "Parts Location",
        "phone": "Phone",
        "prodtargethrs": "Production Target Hours",
        "rbac": {
          "accounting": {
            "exportlog": "Accounting -> Export Log",
            "payables": "Accounting -> Payables",
            "payments": "Accounting -> Payments",
            "receivables": "Accounting -> Receivables"
          },
          "bills": {
            "delete": "Bills -> Delete",
            "enter": "Bills -> Enter",
            "list": "Bills -> List",
            "reexport": "Bills -> Re-export",
            "view": "Bills -> View"
          },
          "contracts": {
            "create": "Contracts -> Create",
            "detail": "Contracts -> Detail",
            "list": "Contracts -> List"
          },
          "courtesycar": {
            "create": "Courtesy Car -> Create",
            "detail": "Courtesy Car -> Detail",
            "list": "Courtesy Car -> List"
          },
          "csi": {
            "export": "CSI -> Export",
            "page": "CSI -> Page"
          },
          "employee_teams": {
            "page": "Employee Teams -> List"
          },
          "employees": {
            "page": "Employees -> List"
          },
          "inventory": {
            "delete": "Inventory -> Delete",
            "list": "Inventory -> List"
          },
          "jobs": {
            "admin": "Jobs -> Admin",
            "available-list": "Jobs -> Available List",
            "checklist-view": "Jobs -> Checklist View",
            "close": "Jobs -> Close",
            "create": "Jobs -> Create",
            "deliver": "Jobs -> Deliver",
            "detail": "Jobs -> Detail",
            "intake": "Jobs -> Intake",
            "list-active": "Jobs -> List Active",
            "list-all": "Jobs -> List All",
            "list-ready": "Jobs -> List Ready",
            "manual-line": "Jobs -> Manual Line",
            "partsqueue": "Jobs -> Parts Queue",
            "void": "Jobs -> Void"
          },
          "owners": {
            "detail": "Owners -> Detail",
            "list": "Owners -> List"
          },
          "payments": {
            "enter": "Payments -> Enter",
            "list": "Payments -> List"
          },
          "phonebook": {
            "edit": "Phonebook -> Edit",
            "view": "Phonebook -> View"
          },
          "production": {
            "board": "Production -> Board",
            "list": "Production -> List"
          },
          "schedule": {
            "view": "Schedule -> View"
          },
          "scoreboard": {
            "view": "Scoreboard -> View"
          },
          "shiftclock": {
            "view": "Shift Clock -> View"
          },
          "shop": {
            "config": "Shop -> Config",
            "dashboard": "Shop -> Dashboard",
            "jobStatus": "Shop -> Job Status",
            "rbac": "Shop -> RBAC",
            "reportcenter": "Shop -> Report Center",
            "responsibilitycenter": "Shop -> Responsibility Centers",
            "templates": "Shop -> Templates",
            "vendors": "Shop -> Vendors"
          },
          "temporarydocs": {
            "view": "Temporary Docs -> View"
          },
          "timetickets": {
            "edit": "Time Tickets -> Edit",
            "editcommitted": "Time Tickets -> Edit Committed",
            "enter": "Time Tickets -> Enter",
            "list": "Time Tickets -> List",
            "shiftedit": "Time Tickets -> Shift Edit"
          },
          "ttapprovals": {
            "approve": "Time Ticket Approval -> Approve",
            "view": "Time Ticket Approval -> View"
          },
          "users": {
            "editaccess": "Users -> Edit access"
          }
        },
        "responsibilitycenter": "Responsibility Center",
        "responsibilitycenter_accountdesc": "Account Description",
        "responsibilitycenter_accountitem": "Item",
        "responsibilitycenter_accountname": "Account Name",
        "responsibilitycenter_accountnumber": "Account Number",
        "responsibilitycenter_rate": "Rate",
        "responsibilitycenter_tax_rate": "Tax {{typeNum}} Tier {{typeNumIterator}} Rate",
        "responsibilitycenter_tax_sur": "Tax {{typeNum}} Tier {{typeNumIterator}} Surcharge",
        "responsibilitycenter_tax_thres": "Tax {{typeNum}} Tier {{typeNumIterator}} Threshold",
        "responsibilitycenter_tax_tier": "Tax {{typeNum}} Tier {{typeNumIterator}}",
        "responsibilitycenter_tax_type": "Tax {{typeNum}} Type",
        "responsibilitycenters": {
          "ap": "Accounts Payable",
          "ar": "Accounts Receivable",
          "ats": "ATS",
          "federal_tax": "Federal Tax",
          "federal_tax_itc": "Federal Tax Credit",
          "gogcode": "GOG / Misc Code",
          "gst_override": "GST Override Account #",
          "invoice_federal_tax_rate_short": "Federal Tax Rate",
          "invoice_local_tax_rate_short": "Local Tax Rate",
          "invoice_state_tax_rate_short": "State Tax Rate",
          "invoiceexemptcode": "QuickBooks US - Invoice Tax Exempt Code",
          "invoiceexemptcode_short": "Invoice Tax Exempt Code",
          "item_type": "Item Type",
          "item_type_freight": "Freight",
          "item_type_gog": "GOG",
          "item_type_misc": "MISC",
          "item_type_paint": "Paint Materials",
          "itemexemptcode": "QuickBooks US - Line Item Tax Exempt Code",
          "itemexemptcode_short": "Line Item Tax Exempt Code",
          "la1": "LA1",
          "la2": "LA2",
          "la3": "LA3",
          "la4": "LA4",
          "laa": "Aluminum",
          "lab": "Body",
          "lad": "Diagnostic",
          "lae": "Electrical",
          "laf": "Frame",
          "lag": "Glass",
          "lam": "Mechanical",
          "lar": "Refinish",
          "las": "Structural",
          "lau": "User Defined",
          "local_tax": "Local Tax",
          "mapa": "Paint Materials",
          "mash": "Shop Materials",
          "nontaxable": "Non-taxable",
          "paa": "Aftermarket",
          "pac": "Chrome",
          "pag": "Glass",
          "pal": "LKQ",
          "pam": "Remanufactured",
          "pan": "OEM",
          "pao": "Other",
          "pap": "OEM Partial",
          "par": "Recored",
          "pas": "Sublet",
          "pasl": "Sublet (L)",
          "refund": "Refund",
          "sales_tax_codes": {
            "code": "Code",
            "description": "Description",
            "federal": "Federal Tax Applies",
            "local": "Local Tax Applies",
            "state": "State Tax Applies"
          },
          "state_tax": "State Tax",
          "taxable": "Taxable",
          "taxable_flag": "Taxable?",
          "tow": "Towing"
        },
        "schedule_end_time": "Schedule Ending Time",
        "schedule_start_time": "Schedule Starting Time",
        "scoreboard_setup": {
          "daily_body_target": "Daily Body Target",
          "daily_paint_target": "Daily Paint Target",
          "ignore_blocked_days": "Ignore Blocked Days",
          "last_number_working_days": "Last Number of Working Days",
          "production_target_hours": "Production Target Hours"
        },
        "shopname": "Shop Name",
        "speedprint": {
          "id": "Id",
          "label": "Label",
          "templates": "Templates"
        },
        "ss_configuration": {
          "dailyhrslimit": "Daily Incoming Hours Limit",
          "nobusinessdays": "Include Weekends"
        },
        "ssbuckets": {
          "color": "Job Color",
          "gte": "Greater Than/Equal to (hrs)",
          "id": "ID",
          "label": "Label",
          "lt": "Less than (hrs)",
          "target": "Target (count)"
        },
        "state": "Province/State",
        "state_tax_id": "State Tax ID",
        "status": "Status Label",
        "statuses": {
          "active_statuses": "Active Statuses (Filtering for Active Jobs throughout system)",
          "additional_board_statuses": "Additional Status to Display on Production Board",
          "color": "Color",
          "default_arrived": "Default Arrived Status (Transition to Production)",
          "default_bo": "Default Backordered Status",
          "default_canceled": "Default Canceled Status",
          "default_completed": "Default Completed Status",
          "default_delivered": "Default Delivered Status (Transition to Post-Production)",
          "default_exported": "Default Exported Status",
          "default_imported": "Default Imported Status",
          "default_invoiced": "Default Invoiced Status",
          "default_ordered": "Default Ordered Status",
          "default_quote": "Default Quote Status",
          "default_received": "Default Received Status",
          "default_returned": "Default Returned",
          "default_scheduled": "Default Scheduled Status",
          "default_void": "Default Void",
          "open_statuses": "Open Statuses",
          "post_production_statuses": "Post-Production Statuses",
          "pre_production_statuses": "Pre-Production Statuses",
          "production_colors": "Production Status Colors",
          "production_statuses": "Production Statuses",
          "ready_statuses": "Ready Statuses"
        },
        "system_settings": {
          "auto_email": {
            "attach_pdf_to_email": "Attach PDF to Sent Emails?",
            "from_emails": "Additional From Emails",
            "parts_order_cc": "Parts Orders CC",
            "parts_return_slip_cc": "Parts Returns CC"
          },
          "job_costing": {
            "paint_hour_split": "Paint Hour Split",
            "paint_materials_hourly_cost_rate": "Paint Materials Hourly Cost Rate",
            "prep_hour_split": "Prep Hour Split",
            "shop_materials_hourly_cost_rate": "Shop Materials Hourly Cost Rate",
            "target_touch_time": "Target Touch Time",
            "use_paint_scale_data": "Use Paint Scale Data"
          },
          "local_media_server": {
            "enabled": "Enabled",
            "http_path": "HTTP Path",
            "network_path": "Network Path",
            "token": "Token"
          },
          "media_tags": "Available tags",
          "media_tags_help": "These tags can be assigned to files from a job gallery. The system folder names bills, thumbs, and ConvertedOriginal cannot be used. Tags assigned to files cannot be removed."
        },
        "target_touchtime": "Target Touch Time",
        "timezone": "Timezone",
        "tt_allow_post_to_invoiced": "Allow Time Tickets to be posted to Invoiced & Exported Jobs",
        "tt_enforce_hours_for_tech_console": "Restrict Claimable Hours",
        "tech_console": {
          "inactivity_timeout_enabled": "Enable inactivity timeout",
          "inactivity_timeout_enabled_help": "When enabled, inactive technicians are automatically logged out of the Tech Console.",
          "inactivity_timeout_help": "The technician is logged out after this many minutes without keyboard, pointer, touch, wheel, or scroll activity. Enter a value from {{min}} to {{max}} minutes.",
          "inactivity_timeout_minutes": "Inactivity timeout",
          "inactivity_timeout_validation": "Enter a whole number from {{min}} to {{max}} minutes.",
          "minutes": "minutes"
        },
        "use_fippa": "Conceal Customer Information on Generated Documents?",
        "use_paint_scale_data": "Use Paint Scale Data for Job Costing?",
        "uselocalmediaserver": "Use Local Media Server?",
        "website": "Website",
        "zip_post": "Zip/Postal Code"
      },
      "labels": {
        "2tiername": "Name => RO",
        "2tiersetup": "2 Tier Setup",
        "2tiersource": "Source => RO",
        "accountingsetup": "Accounting Setup",
        "accountingtiers": "Number of Tiers to Use for Export",
        "alljobstatuses": "All Job Statuses",
        "allopenjobstatuses": "All Open Job Statuses",
        "apptcolors": "Appointment Colors",
        "autoemail": "Auto Email",
        "businessinformation": "Business Information",
        "checklists": "Checklists",
        "consent_settings": "Phone Number Opt-Out List",
        "csiq": "CSI Questions",
        "customtemplates": "Custom Templates",
        "defaultcostsmapping": "Default Costs Mapping",
        "defaultprofitsmapping": "Default Profits Mapping",
        "deliverchecklist": "Delivery Checklist",
        "dms": {
          "cdk": {
            "controllist": "Control Number List",
            "payers": "Payers"
          },
          "cdk_dealerid": "CDK Dealer ID",
          "costsmapping": "Costs Mapping",
          "dms_allocations": "DMS Allocations",
          "pbs_serialnumber": "PBS Serial Number",
          "profitsmapping": "Profits Mapping",
          "rr_dealerid": "Reynolds Store Number",
          "title": "DMS"
        },
        "dms_setup": "DMS Setup",
        "emaillater": "Email Later",
        "employee_options": "Employee Options",
        "employee_rates": "Employee Rates",
        "employee_teams": "Employee Teams",
        "employee_vacation": "Employee Vacation",
        "employees": "Employees",
        "estimators": "Estimators",
        "filehandlers": "Adjusters",
        "imexpay": "ImEX Pay",
        "insurancecos": "Insurance Companies",
        "intake_delivery": "Intake / Delivery Options",
        "intakechecklist": "Intake Checklist",
        "intellipay_cash_discount": "Please ensure that cash discounting has been enabled on your merchant account. Reach out to IntelliPay Support if you need assistance. ",
        "job_status_options": "Job Status Options",
        "jobcosting": "Job Costing",
        "jobstatuses": "Job Statuses",
        "jump_to_section": "Jump to section",
        "laborrates": "Labor Rates",
        "licensing": "Licensing",
        "localmediaserver": "Local Media Server",
        "media_tag_in_use": "This tag is in use and cannot be removed.",
        "media_tags": "Image and Document Tags",
        "md_parts_scan": "Parts Scan Rules",
        "md_ro_guard": "RO Guard",
        "md_ro_guard_options": "RO Guard Options",
        "md_tasks_presets": "Tasks Presets",
        "md_to_emails": "Preset To Emails",
        "md_to_emails_emails": "Emails",
        "messagingpresets": "Messaging Presets",
        "notemplatesavailable": "No templates available to add.",
        "notespresets": "Notes Presets",
        "notification_options": "Notification Options",
        "notifications": {
          "followers": "Notifications"
        },
        "orderstatuses": "Order Statuses",
        "parts_shop_management": "Shop Management",
        "parts_vendor_management": "Vendor Management",
        "partslocations": "Parts Locations",
        "partsscan": "Parts Scanning",
        "printlater": "Print Later",
        "qbo": "Use QuickBooks Online?",
        "qbo_departmentid": "QBO Department ID",
        "qbo_usa": "QBO USA Compatibility",
        "rbac": "Role Based Access Control",
        "rbac_options": "Role Based Access Control Options",
        "tech_console": "Tech Console",
        "tech_console_options": "Tech Console Options",
        "responsibilitycenters": {
          "costs": "Cost Centers",
          "default_tax_setup": "Default Tax Setup",
          "invoices": "Invoices",
          "profits": "Profit Centers",
          "quickbooks_qbd": "QuickBooks / QBD",
          "quickbooks_us": "QuickBooks US",
          "sales_tax_codes": "Sales Tax Codes",
          "tax_accounts": "Tax Accounts",
          "tax_rate_short": "Rate",
          "tax_surcharge_short": "Surcharge",
          "tax_threshold_short": "Threshold",
          "tax_tier_card": "Tier {{typeNumIterator}}",
          "tax_tier_short": "Tier",
          "tax_type_card": "Tax Type {{typeNum}}",
          "title": "Responsibility Centers",
          "ttl_adjustment": "Subtotal Adjustment Account",
          "ttl_tax_adjustment": "Tax Adjustment Account"
        },
        "roguard": {
          "title": "RO Guard"
        },
        "romepay": "Rome Pay",
        "scheduling": "SMART Scheduling",
        "scoreboardsetup": "Scoreboard Setup",
        "shop_enabled_features": "Shop Enabled Features",
        "shopinfo": "Shop Information",
        "shoprates": "Shop Rates",
        "speedprint": "Speed Print Configuration",
        "speedprint_configurations": "Speed Print Configurations",
        "ssbuckets": "Job Size Definitions",
        "systemsettings": "System Settings",
        "task-presets": "Task Presets",
        "task_preset_options": "Task Preset Options",
        "workingdays": "Working Days"
      },
      "operations": {
        "contains": "Contains",
        "ends_with": "Ends With",
        "equals": "Equals",
        "greater_than": "Greater Than",
        "less_than": "Less Than",
        "not_equals": "Not Equals",
        "starts_with": "Starts With"
      },
      "successes": {
        "areyousure": "Are you sure you want to continue?",
        "defaultviewcreated": "Default view created successfully.",
        "save": "Shop configuration saved successfully. ",
        "unsavedchanges": "Unsaved changes will be lost. Are you sure you want to continue?"
      },
      "tooltips": {
        "md_parts_scan": {
          "update_value_tooltip": "Some fields require coded values in order to function properly (e.g.  labor and part types).  Please reach out to support if you have any questions."
        },
        "reset-color": "Reset color"
      },
      "validation": {
        "centermustexist": "The chosen responsibility center does not exist.",
        "duplicatecentername": "A responsibility center with this name already exists.",
        "larsplit": "Refinish hour split must add up to 1.",
        "useremailmustexist": "This email is not a valid user."
      }
    },
    "checklist": {
      "actions": {
        "printall": "Print All Documents"
      },
      "errors": {
        "complete": "Error during Job checklist completion. {{error}}",
        "nochecklist": "No checklist has been configured for your shop. "
      },
      "labels": {
        "addtoproduction": "Add Job to Production?",
        "checklist": "Checklist",
        "printpack": "Job Intake Print Pack",
        "removefromproduction": "Remove Job from Production?"
      },
      "successes": {
        "completed": "Job checklist completed."
      }
    },
    "commandpalette": {
      "hints": {
        "close": "close",
        "navigate": "navigate",
        "select": "open"
      },
      "noresults": "No results for \"{{search}}\"",
      "placeholder": "Search jobs, customers, vehicles or type a command...",
      "sections": {
        "actions": "Quick Actions",
        "pages": "Go to Page",
        "recent": "Recent"
      },
      "tooltip": "Search & Commands (Ctrl+K)"
    },
    "consent": {
      "associated_owners": "Associated Owners",
      "created_at": "Opt-Out Date",
      "no_owners": "No Associated Owners",
      "phone_1": "Phone 1",
      "phone_2": "Phone 2",
      "phone_number": "Phone Number",
      "text_body": "Users can opt out of receiving SMS messages by replying with keywords such as STOP, UNSUBSCRIBE, CANCEL, END, QUIT, STOPALL, REVOKE and OPTOUT. To opt back in, users can reply with START, YES, or UNSTOP. Even after opting out, users can still send messages to us, which will be received and processed as needed. Ensure customers are informed to reply with these keywords to manage their messaging preferences. After opting out, users receive a confirmation message and will not receive further messages until they opt back in."
    },
    "contracts": {
      "actions": {
        "changerate": "Change Contract Rates",
        "convertoro": "Convert to RO",
        "decodelicense": "Decode License",
        "find": "Find Contract",
        "printcontract": "Print Contract",
        "senddltoform": "Insert Driver's License Information"
      },
      "errors": {
        "fetchingjobinfo": "Error fetching Job Info. {{error}}.",
        "returning": "Error returning Courtesy Car. {{error}}",
        "saving": "Error saving Contract. {{error}}",
        "selectjobandcar": "Please ensure both a car and job are selected."
      },
      "fields": {
        "actax": "A/C Tax",
        "actualreturn": "Actual Return Date",
        "agreementnumber": "Agreement Number",
        "cc_cardholder": "Cardholder Name",
        "cc_expiry": "Credit Card Expiry Date",
        "cc_num": "Credit Card Number",
        "cleanupcharge": "Clean Up Charge",
        "coverage": "Coverage",
        "dailyfreekm": "Daily Free Mileage",
        "dailyrate": "Daily Rate",
        "damage": "Existing Damage",
        "damagewaiver": "Damage Waiver",
        "driver": "Driver",
        "driver_addr1": "Driver Address 1",
        "driver_addr2": "Driver Address 2",
        "driver_city": "Driver City",
        "driver_dlexpiry": "Driver's License Expiration Date",
        "driver_dlnumber": "Driver's License Number",
        "driver_dlst": "Driver's License Province/State",
        "driver_dob": "Driver's DOB",
        "driver_fn": "Driver's First Name",
        "driver_ln": "Driver's Last Name",
        "driver_ph1": "Driver's Phone",
        "driver_state": "Driver's Province/State ",
        "driver_zip": "Driver's Postal/ZIP Code",
        "excesskmrate": "Excess Mileage",
        "federaltax": "Federal Taxes",
        "fuelin": "Fuel In",
        "fuelout": "Fuel Out",
        "kmend": "Mileage End",
        "kmstart": "Mileage Start",
        "length": "Length",
        "localtax": "Local Taxes",
        "refuelcharge": "Refuel Charge (per liter/gallon)",
        "scheduledreturn": "Scheduled Return",
        "start": "Contract Start",
        "statetax": "Provincial/State Taxes",
        "status": "Status"
      },
      "labels": {
        "agreement": "Agreement {{agreement_num}} - {{status}}",
        "availablecars": "Available Cars",
        "cardueforservice": "The courtesy car is due for servicing.",
        "convertform": {
          "applycleanupcharge": "Apply cleanup charge?",
          "refuelqty": "Refuel qty.?"
        },
        "correctdataonform": "Please review the information above. If any of it is not correct, you can fix it later.",
        "dateinpast": "Date is in the past.",
        "dlexpirebeforereturn": "The driver's license expires before the car is expected to return. ",
        "driverinformation": "Driver's Information",
        "findcontract": "Find Contract",
        "findermodal": "Contract Finder",
        "insuranceexpired": "The courtesy car insurance expires before the car is expected to return.",
        "noteconvertedfrom": "R.O. created from converted Courtesy Car Contract {{agreementnumber}}.",
        "populatefromjob": "Populate from Job",
        "rates": "Contract Rates",
        "time": "Time",
        "vehicle": "Vehicle",
        "waitingforscan": "Please scan driver's license barcode..."
      },
      "status": {
        "new": "New Contract",
        "out": "Out",
        "returned": "Returned"
      },
      "successes": {
        "saved": "Contract saved successfully. "
      }
    },
    "courtesycars": {
      "actions": {
        "new": "New Courtesy Car",
        "return": "Return Car"
      },
      "errors": {
        "saving": "Error saving Courtesy Car. {{error}}"
      },
      "fields": {
        "color": "Color",
        "dailycost": "Daily Cost to Rent",
        "damage": "Damage",
        "fleetnumber": "Fleet Number",
        "fuel": "Fuel Level",
        "insuranceexpires": "Insurance Expires On",
        "leaseenddate": "Lease Ends On",
        "make": "Make",
        "mileage": "Mileage",
        "model": "Model",
        "nextservicedate": "Next Service Date",
        "nextservicekm": "Next Service KMs",
        "notes": "Notes",
        "plate": "Plate Number",
        "purchasedate": "Purchase Date",
        "readiness": "Readiness",
        "registrationexpires": "Registration Expires On",
        "serviceenddate": "Usage End Date",
        "servicestartdate": "Usage Start Date",
        "status": "Status",
        "vin": "VIN",
        "year": "Year"
      },
      "labels": {
        "courtesycar": "Courtesy Car",
        "fuel": {
          "12": "1/2",
          "14": "1/4",
          "18": "1/8",
          "34": "3/4",
          "38": "3/8",
          "58": "5/8",
          "78": "7/8",
          "empty": "Empty",
          "full": "Full"
        },
        "outwith": "Out With",
        "return": "Return Courtesy Car",
        "status": "Status",
        "uniquefleet": "Enter a unique fleet number.",
        "usage": "Usage",
        "vehicle": "Vehicle Description"
      },
      "readiness": {
        "notready": "Not Ready",
        "ready": "Ready"
      },
      "status": {
        "in": "Available",
        "inservice": "Service/Maintenance",
        "leasereturn": "Lease Returned",
        "out": "Rented",
        "sold": "Sold",
        "unavailable": "Unavailable"
      },
      "successes": {
        "saved": "Courtesy Car saved successfully."
      }
    },
    "csi": {
      "actions": {
        "activate": "Activate"
      },
      "errors": {
        "creating": "Error creating survey {{message}}",
        "notconfigured": "You do not have any current CSI Question Sets configured.",
        "notfoundsubtitle": "We were unable to find a survey using the link you provided. Please ensure the URL is correct or reach out to your shop for more help.",
        "notfoundtitle": "No survey found.",
        "surveycompletesubtitle": "",
        "surveycompletetitle": ""
      },
      "fields": {
        "completedon": "Completed On",
        "created_at": "Created At",
        "surveyid": "",
        "validuntil": ""
      },
      "labels": {
        "copyright": "",
        "greeting": "",
        "intro": "",
        "nologgedinuser": "Please log out of {{app}}",
        "nologgedinuser_sub": "Users of {{app}} cannot complete CSI surveys while logged in. Please log out and try again.",
        "noneselected": "No response selected.",
        "title": "Customer Satisfaction Survey"
      },
      "successes": {
        "created": "CSI created successfully. ",
        "submitted": "Your responses have been submitted successfully.",
        "submittedsub": "Your input is highly appreciated."
      }
    },
    "dashboard": {
      "actions": {
        "addcomponent": "Add Component"
      },
      "errors": {
        "atp": "No Alt. Transport*",
        "insco": "No Ins. Co.*",
        "refreshrequired": "You must refresh the dashboard data to see this component.",
        "status": "No Status*",
        "status_normal": "No Status",
        "updatinglayout": "Error saving updated layout {{message}}"
      },
      "labels": {
        "asoftoday": "As of today",
        "attarget": "At target",
        "belowtarget": "Below target",
        "bodyhrs": "Body Hrs",
        "dollarsinproduction": "Dollars in Production",
        "duein": "Due in {{time}}",
        "efficiencychart": "Efficiency %",
        "emptydeliverytoday": "Nothing scheduled for delivery today.",
        "emptyhint": "New appointments will appear here as they're scheduled.",
        "emptyintoday": "No vehicles scheduled to arrive today.",
        "emptyouttoday": "Nothing scheduled to complete today.",
        "emptyproductionstatus": "No jobs currently in production.",
        "hourschart": "Hours",
        "jobs": "Jobs",
        "jobscount": "{{count}} jobs",
        "newperiod": "New this period",
        "overdue": "Overdue",
        "overdueby": "Overdue by {{time}}",
        "overduecount": "{{count}} overdue",
        "phone": "Phone",
        "prodhrs": "Production Hrs",
        "prodhrsvstarget": "Production Hrs vs target",
        "refhrs": "Refinish Hrs",
        "status": "Status",
        "subtotal": "Subtotal",
        "tableview": "Table",
        "targethrs": "target {{value}} hrs",
        "todaycount": "{{count}} today",
        "total": "Total",
        "tvview": "TV",
        "vslastmonth": "{{percent}}% vs last month",
        "vslastyear": "{{percent}}% vs last year",
        "yeartodatesales": "Year-to-Date Sales",
        "unknownstatus": "Unknown"
      },
      "titles": {
        "joblifecycle": "Job Life Cycles",
        "labhours": "Total Body Hours",
        "larhours": "Total Refinish Hours",
        "monthlyemployeeefficiency": "Monthly Employee Efficiency",
        "monthlyjobcosting": "Monthly Job Costing ",
        "monthlylaborsales": "Monthly Labor Sales",
        "monthlypartssales": "Monthly Parts Sales",
        "monthlyrevenuegraph": "Monthly Revenue Graph",
        "prodhrssummary": "Production Hours Summary",
        "productiondollars": "Total Dollars in Production",
        "productionhours": "Total Hours in Production",
        "productionstatussummary": "Production Status Summary",
        "projectedmonthlysales": "Projected Monthly Sales",
        "scheduleddeliverydate": "Scheduled Delivery Date: {{date}}",
        "scheduleddeliverytoday": "Scheduled Delivery Today",
        "scheduledindate": "Scheduled In Today: {{date}}",
        "scheduledintoday": "Scheduled In Today",
        "scheduledoutdate": "Scheduled Out Today: {{date}}",
        "scheduledouttoday": "Scheduled Out Today",
        "tasks": "Tasks",
        "yeartodatesales": "Year-to-Date Sales"
      }
    },
    "dms": {
      "errors": {
        "alreadyexported": "This job has already been sent to the DMS. If you need to resend it, please use admin permissions to mark the job for re-export.",
        "earlyrorequired": "Early RO Required",
        "earlyrorequired.message": "This job requires an early Repair Order to be created before posting to Reynolds. Please use the admin panel to create the early RO first."
      },
      "labels": {
        "banner_message": "Posting to {{provider}} | {{transport}} | {{status}}",
        "banner_status_connected": "Connected",
        "banner_status_disconnected": "Disconnected",
        "clear_logs": "Clear Logs",
        "collapse_all": "Collapse All",
        "color_json": "Color JSON",
        "copied": "Copied",
        "copy": "Copy",
        "copy_request": "Copy Request",
        "copy_response": "Copy Response",
        "details": "Details",
        "expand_all": "Expand All",
        "hide_details": "Hide details",
        "log_level": "Log Level",
        "plain_json": "Plain JSON",
        "provider_cdk": "CDK",
        "provider_dms": "DMS",
        "provider_fortellis": "Fortellis",
        "provider_pbs": "PBS",
        "provider_reynolds": "Reynolds",
        "reconnect": "Reconnect",
        "reconnected_export_service": "Reconnected to {{provider}} Export Service",
        "refreshallocations": "Refresh to see DMS Allocations.",
        "request_xml": "Request XML",
        "response_xml": "Response XML",
        "rr_validation_message": "Repair Order created in Reynolds. Complete validation in Reynolds, then click Finished/Close to finalize.",
        "rr_validation_notice_description": "Complete validation in Reynolds, then click Finished/Close to finalize and mark this export complete.",
        "rr_validation_notice_title": "Reynolds RO created",
        "transport_ws": "(WS)",
        "transport_wss": "(WSS)"
      },
      "rr_allocations_preview": {
        "columns": {
          "amt_type": "AmtType",
          "bill_rate": "BillRate",
          "bill_time": "BillTime",
          "break_out": "BreakOut",
          "code_amt": "CodeAmt",
          "cust_pay_type": "CustPayType",
          "cust_price": "CustPrice",
          "cust_qty": "CustQty",
          "cust_txbl_flag": "CustTxblFlag",
          "dlr_cost": "DlrCost",
          "item_desc": "ItemDesc",
          "item_type": "ItemType",
          "job_no": "JobNo",
          "job_total_hrs": "JobTotalHrs",
          "misc_code": "MiscCode",
          "op_code": "OpCode",
          "pay_type": "PayType",
          "total_amt": "TotalAmt"
        },
        "descriptions": {
          "gog": "Only centers with RR GOG mapping (rr_gogcode & rr_item_type) are included. Totals below reflect exactly what will be sent in ROGOG, with parts, extras, and labor split into taxable / non-taxable segments.",
          "labor": "This mirrors the labor rows RR will receive, including weighted bill hours and rates derived from the job's labor lines.",
          "misc": "Centers configured with item type MISC are sent in ROMISC using the configured GOG / Misc Code as MiscCode."
        },
        "empty": {
          "gog": "No ROGOG lines would be generated.",
          "labor": "No ROLABOR lines would be generated.",
          "misc": "No ROMISC lines would be generated."
        },
        "labels": {
          "op_code": "OpCode:"
        },
        "segments": {
          "extras_non_taxable": "Extras Non-Taxable",
          "extras_taxable": "Extras Taxable",
          "labor_non_taxable": "Labor Non-Taxable",
          "labor_taxable": "Labor Taxable",
          "parts_non_taxable": "Parts Non-Taxable",
          "parts_taxable": "Parts Taxable"
        },
        "tabs": {
          "gog": "GOG Preview",
          "labor": "LABOR Preview",
          "misc": "MISC Preview"
        }
      }
    },
    "documents": {
      "actions": {
        "delete": "Delete Selected Files",
        "download": "Download Selected Files",
        "reassign": "Reassign to another Job",
        "selectfiles": "Select Files",
        "selectallimages": "Select All Images",
        "selectallotherdocuments": "Select All Documents",
        "applytag": "Apply Tags"
      },
      "errors": {
        "deletes3": "Error deleting document from storage. ",
        "deleting": "Error deleting documents {{error}}",
        "deleting_cloudinary": "Error deleting document from storage. {{message}}",
        "getpresignurl": "Error obtaining presigned URL for document.  {{message}}",
        "insert": "Unable to upload file. {{message}}",
        "lms_mobile_browser": "Local Media Server images aren’t available in a mobile browser. Please use the mobile app to view or attach them.",
        "lms_unavailable": "Unable to load images from the Local Media Server. Check your connection to the shop network and try again.",
        "nodocuments": "There are no documents.",
        "updating": "Error updating document. {{error}}"
      },
      "labels": {
        "confirmdelete": "Are you sure you want to delete these files? This cannot be undone.",
        "alltags": "All tags",
        "doctype": "Document Type",
        "dragtoupload": "Click or drag files to this area to upload",
        "fileactions": "File access",
        "greyscale": "Greyscale",
        "filtertag": "Filter by tag",
        "lightboxtag": "Tag: {{tag}}",
        "newjobid": "Assign to Job",
        "openinexplorer": "Open in Explorer",
        "optimizedimage": "The below image is optimized. Click on the picture below to open in a new window and view it full size, or open it in explorer.",
        "reassign_limitexceeded": "Reassigning all selected documents will exceed the job storage limit for your shop.  ",
        "reassign_limitexceeded_title": "Unable to reassign document(s)",
        "storageexceeded": "You've exceeded your storage limit for this job. Please remove documents, or increase your storage plan.",
        "storageexceeded_title": "Storage Limit Exceeded",
        "selecttag": "Select a tag",
        "selectedactions": "Selected Files",
        "selectionactions": "Selection",
        "tagassignment": "Apply Tags",
        "tagfilter": "Filter by Tag",
        "untagged": "Untagged",
        "upload": "Upload",
        "upload_limitexceeded": "Uploading all selected documents will exceed the job storage limit for your shop.  ",
        "upload_limitexceeded_title": "Unable to upload document(s)",
        "uploading": "Uploading...",
        "usage": "of Job storage used.  ({{used}} / {{total}})"
      },
      "successes": {
        "delete": "Document(s) deleted successfully.",
        "edituploaded": "Edited document uploaded successfully. This window can now be closed.",
        "insert": "Uploaded document successfully. ",
        "updated": "Document updated successfully. "
      }
    },
    "emails": {
      "errors": {
        "notsent": "Email not sent. Error encountered while sending {{message}}"
      },
      "fields": {
        "cc": "CC",
        "from": "From",
        "subject": "Subject",
        "to": "To"
      },
      "labels": {
        "attachments": "Attachments",
        "documents": "Documents",
        "emailpreview": "Email Preview",
        "generatingemail": "Generating email...",
        "pdfcopywillbeattached": "A PDF copy of this email will be attached when it is sent.",
        "preview": "Email Preview"
      },
      "successes": {
        "sent": "Email sent successfully."
      }
    },
    "employee_teams": {
      "actions": {
        "new": "New Team",
        "newmember": "New Team Member",
        "save_team": "Save Employee Team"
      },
      "errors": {
        "allocation_total_exact": "Team allocation must total exactly 100%.",
        "duplicate_member": "Each employee can only appear once per team.",
        "minimum_one_member": "Add at least one team member."
      },
      "fields": {
        "active": "Active",
        "allocation": "Allocation",
        "allocation_percentage": "Allocation %",
        "employeeid": "Employee",
        "max_load": "Max Load",
        "name": "Team Name",
        "payout_method": "Payout Method",
        "percentage": "Percent"
      },
      "labels": {
        "allocation_total": "Allocation Total: {{total}}%",
        "members": "Members",
        "team_options": "Team Options"
      },
      "options": {
        "commission": "Commission",
        "commission_percentage": "Commission %",
        "hourly": "Hourly"
      }
    },
    "employees": {
      "actions": {
        "addrate": "Add Rate",
        "addvacation": "Add Vacation",
        "new": "New Employee",
        "newrate": "New Rate",
        "save_employee": "Save Employee",
        "select": "Select Employee"
      },
      "errors": {
        "delete": "Error encountered while deleting employee. {{message}}",
        "save": "Error encountered saving employee. {{message}}",
        "validation": "Please check all fields.",
        "validationtitle": "Unable to save employee."
      },
      "fields": {
        "active": "Active?",
        "base_rate": "Base Rate",
        "cost_center": "Cost Center",
        "employee_number": "Employee Number",
        "external_id": "External Employee ID",
        "external_rate_code": "External Rate Code",
        "first_name": "First Name",
        "flat_rate": "Flat Rate (Disabled is Straight Time)",
        "hire_date": "Hire Date",
        "last_name": "Last Name",
        "pin": "Tech Console PIN",
        "rate": "Rate",
        "termination_date": "Termination Date",
        "user_email": "User Email",
        "vacation": {
          "end": "Vacation End",
          "length": "Vacation Length",
          "start": "Vacation Start"
        }
      },
      "labels": {
        "actions": "Actions",
        "active": "Active",
        "employee_number_short": "Employee #",
        "endmustbeafterstart": "End date must be after start date.",
        "flat_rate": "Flat Rate",
        "inactive": "Inactive",
        "name": "Name",
        "rate_type": "Rate Type",
        "status": "Status",
        "straight_time": "Straight Time"
      },
      "successes": {
        "delete": "Employee deleted successfully.",
        "save": "Employee saved successfully.",
        "vacationadded": "Employee vacation added."
      },
      "validation": {
        "unique_employee_number": "You must enter a unique employee number.",
        "unique_user_email": "This email is already assigned to another employee."
      }
    },
    "esignature": {
      "actions": {
        "delete": "Delete",
        "distribute": "Distribute",
        "redistribute": "Redistribute",
        "upload_document": "Upload Document for E-Sign",
        "view": "View"
      },
      "confirm": {
        "discard_title": "Discard this document?",
        "discard_content": "The uploaded document and any fields you have placed will be permanently deleted from the signing server.",
        "discard_ok": "Discard",
        "discard_cancel": "Keep editing"
      },
      "errors": {
        "no_token": "Error connecting to signing server.  No authorization token was provided.",
        "pdf_only": "Only PDF documents can be uploaded for e-signature.",
        "upload_title": "Unable to prepare document for e-signature"
      },
      "tooltips": {
        "contact_sales": "E-signatures are not enabled for this shop. Contact sales to add this feature.",
        "distribute_checking": "Checking the document status...",
        "distribute_incomplete": "Complete the document setup in the editor and click Save before distributing.",
        "distribute_missing_fields": "Add a signature field for {{recipients}} in the editor, then click Save to enable distribution."
      },
      "fields": {
        "completed": "Completed?",
        "completed_at": "Completed At",
        "created_at": "Created At",
        "external_document_id": "Ex.  Document ID",
        "opened": "Opened?",
        "rejected": "Rejected?",
        "status": "Status",
        "title": "Title",
        "updated_at": "Updated At"
      }
    },
    "eula": {
      "buttons": {
        "accept": "Accept EULA"
      },
      "content": {
        "never_scrolled": "You must scroll to the bottom of the Terms and Conditions before accepting."
      },
      "errors": {
        "acceptance": {
          "description": "Something went wrong while accepting the EULA. Please try again.",
          "message": "Eula Acceptance Error"
        }
      },
      "labels": {
        "accepted_terms": "I accept the terms and conditions of this agreement.",
        "address": "Address",
        "business_name": "Legal Business Name",
        "date_accepted": "Date Accepted",
        "first_name": "First Name",
        "last_name": "Last Name",
        "phone_number": "Phone Number"
      },
      "messages": {
        "accepted_terms": "Please accept the terms and conditions of this agreement.",
        "business_name": "Please enter your legal business name.",
        "date_accepted": "Please enter Today's Date.",
        "first_name": "Please enter your first name.",
        "last_name": "Please enter your last name.",
        "phone_number": "Please enter your phone number."
      },
      "titles": {
        "modal": "Terms and Conditions",
        "upper_card": "Acknowledgement"
      }
    },
    "exportlogs": {
      "fields": {
        "createdat": "Created At"
      },
      "labels": {
        "attempts": "Export Attempts",
        "priorsuccesfulexport": "This record has previously been exported successfully.  Please make sure it has already been deleted in the target system."
      }
    },
    "general": {
      "actions": {
        "add": "Add",
        "addtoproduction": "Courtesy Car - Add to Production",
        "autoupdate": "{{app}} will automatically update in {{time}} seconds. Please save all changes.",
        "calculate": "Calculate",
        "cancel": "Cancel",
        "clear": "Clear",
        "connectquickbooks": "Connect to QuickBooks",
        "close": "Close",
        "copied": "Copied!",
        "copylink": "Copy Link",
        "create": "Create",
        "defaults": "Defaults",
        "delay": "Delay Update (5 mins)",
        "delete": "Delete",
        "deleteall": "Delete All",
        "deselectall": "Deselect All",
        "done": "Done",
        "download": "Download",
        "edit": "Edit",
        "fliphorizontal": "Flip horizontally",
        "flipvertical": "Flip vertically",
        "gotoadmin": "Go to Admin Panel",
        "login": "Login",
        "next": "Next",
        "ok": "Ok",
        "optional": "Optional",
        "or": "or",
        "previous": "Previous",
        "print": "Print",
        "refresh": "Refresh",
        "remove": "Remove",
        "remove_alert": "Are you sure you want to dismiss the alert?",
        "reset": "Reset your changes.",
        "resetpassword": "Reset Password",
        "rotateleft": "Rotate left",
        "rotateright": "Rotate right",
        "save": "Save",
        "saveandnew": "Save and New",
        "saveas": "Save As",
        "select": "Select",
        "selectall": "Select All",
        "send": "Send",
        "sendbysms": "Send by SMS",
        "senderrortosupport": "Send Error to Support",
        "sharetoteams": "Share to Teams",
        "submit": "Submit",
        "tryagain": "Try Again",
        "view": "View",
        "viewreleasenotes": "See What's Changed",
        "zoomin": "Zoom in",
        "zoomout": "Zoom out"
      },
      "errors": {
        "fcm": "You must allow notification permissions to have real time messaging.  Click to try again.",
        "notfound": "No record was found.",
        "sizelimit": "The selected items exceed the size limit.",
        "sub_status": {
          "expired": "The subscription for this shop has expired. Please contact Sales to reactivate.",
          "trial-expired": "The trial for this shop has expired. Please contact Sales to reactivate.",
          "undefined": "The subscription for this shop is removed. Please contact Sales to reactivate."
        },
        "submit-for-testing": "Error submitting Job for testing."
      },
      "itemtypes": {
        "contract": "CC Contract",
        "courtesycar": "Courtesy Car",
        "job": "Job",
        "owner": "Owner",
        "vehicle": "Vehicle"
      },
      "labels": {
        "actions": "Actions",
        "apply": "Apply",
        "areyousure": "Are you sure?",
        "barcode": "Barcode",
        "beta": "BETA",
        "cancel": "Are you sure you want to cancel? Your changes will not be saved.",
        "changelog": "Change Log",
        "clear": "Clear",
        "click_to_begin": "Click {{action}} to begin",
        "confirmpassword": "Confirm Password",
        "created_at": "Created At",
        "date": "Select Date",
        "datetime": "Select Date & Time",
        "email": "Email",
        "errors": "Errors",
        "excel": "Excel",
        "exceptiontitle": "An error has occurred.",
        "feature-request": "Have a feature request?",
        "friday": "Friday",
        "globalsearch": "Global Search",
        "help": "Help",
        "hours": "hrs",
        "in": "In",
        "instanceconflictext": "Your {{app}} account can only be used on one device at any given time. Refresh your session to take control.",
        "instanceconflictitle": "Your account is being used elsewhere.",
        "item": "Item",
        "label": "Label",
        "loading": "Loading...",
        "loadingapp": "Loading {{app}}",
        "loadingshop": "Loading shop data...",
        "loggingin": "Authorizing...",
        "markedexported": "Manually marked as exported.",
        "media": "Media",
        "message": "Message",
        "monday": "Monday",
        "na": "N/A",
        "newpassword": "New Password",
        "no": "No",
        "nointernet": "It looks like you're not connected to the internet.",
        "nointernet_sub": "Please check your connection and try again. ",
        "none": "None",
        "out": "Out",
        "password": "Password",
        "passwordresetsuccess": "A password reset link has been sent to you.",
        "passwordresetsuccess_sub": "You should receive this email in the next few minutes. Please check your email including any junk or spam folders. ",
        "passwordresetvalidatesuccess": "Password successfully reset. ",
        "passwordresetvalidatesuccess_sub": "You may now sign in again using your new password. ",
        "passwordsdonotmatch": "The passwords you have entered do not match.",
        "print": "Print",
        "refresh": "Refresh",
        "reports": "Reports",
        "required": "Required",
        "saturday": "Saturday",
        "search": "Search...",
        "searchresults": "Results for {{search}}",
        "selectdate": "Select date...",
        "selected": "Selected",
        "sendagain": "Send Again",
        "sendby": "Send By",
        "settings": "Settings",
        "signin": "Sign In",
        "sms": "SMS",
        "status": "Status",
        "sub_status": {
          "expired": "The subscription for this shop has expired.  Please contact technical support to reactivate the subscription. "
        },
        "successful": "Successful",
        "sunday": "Sunday",
        "text": "Text",
        "thursday": "Thursday",
        "time": "Select Time",
        "total": "Total",
        "totals": "Totals",
        "tuesday": "Tuesday",
        "tvmode": "TV Mode",
        "unknown": "Unknown",
        "unsavedchanges": "Unsaved changes.",
        "username": "Username",
        "validationerror": "Please fix the following errors:",
        "view": "View",
        "wednesday": "Wednesday",
        "yes": "Yes"
      },
      "languages": {
        "english": "English",
        "french": "French",
        "spanish": "Spanish"
      },
      "messages": {
        "exception": "{{app}} has encountered an error. Please try again. If the problem persists, please submit a support ticket or contact us.",
        "newversionmessage": "Click refresh below to update to the latest available version of {{app}}.  Please make sure all other tabs and windows are closed.",
        "newversiontitle": "New version of {{app}} Available",
        "noacctfilepath": "There is no accounting file path set. You will not be able to export any items.",
        "nofeatureaccess": "You do not have access to this feature of {{app}}.  Please contact support to request a license for this feature.",
        "noshop": "You do not have access to any shops. Please reach out to your shop manager or technical support. ",
        "notfoundsub": "Please make sure that you have access to the data or that the link is correct.",
        "notfoundtitle": "We couldn't find what you're looking for...",
        "partnernotrunning": "{{app}} has detected that the partner is not running. Please ensure it is running to enable full functionality.",
        "rbacunauth": "You are not authorized to view this content. Please reach out to your shop manager to change your access level.",
        "submit-for-testing": "Submitted Job for testing successfully.",
        "unsavedchanges": "You have unsaved changes.",
        "unsavedchangespopup": "You have unsaved changes. Are you sure you want to leave?"
      },
      "validation": {
        "array": "Please select at least one option.",
        "dateRangeExceeded": "The date range has been exceeded.",
        "invalidemail": "Please enter a valid email.",
        "invalidphone": "Please enter a valid phone number.",
        "minlength": "Must be at least {{min}} characters.",
        "required": "{{label}} is required."
      }
    },
    "help": {
      "actions": {
        "connect": "Connect"
      },
      "labels": {
        "codeplacholder": "6 digit PIN code",
        "rescuedesc": "Enter the 6 digit code provided by {{app}} Support below and click connect.",
        "rescuetitle": "Rescue Me!"
      }
    },
    "intake": {
      "labels": {
        "printpack": "Intake Print Pack"
      }
    },
    "inventory": {
      "actions": {
        "addtoinventory": "Add to Inventory",
        "addtoro": "Add to RO",
        "consumefrominventory": "Consume from Inventory?",
        "edit": "Edit Inventory LIne",
        "new": "New Inventory Line"
      },
      "errors": {
        "inserting": "Error inserting inventory item.  {{error}}"
      },
      "fields": {
        "comment": "Comment",
        "manualinvoicenumber": "Invoice Number",
        "manualvendor": "Vendor"
      },
      "labels": {
        "consumedbyjob": "Consumed by Job",
        "deleteconfirm": "Are you sure you want to delete this from inventory? The associated bill will not be modified or deleted. ",
        "frombillinvoicenumber": "Original Bill Invoice Number",
        "fromvendor": "Original Bill Vendor",
        "inventory": "Inventory",
        "showall": "Show All Inventory",
        "showavailable": "Show Only Available Inventory"
      },
      "successes": {
        "deleted": "Inventory lined deleted.",
        "inserted": "Added line to inventory.",
        "updated": "Inventory line updated."
      }
    },
    "job_lifecycle": {
      "columns": {
        "average_human_readable": "Average Human Readable",
        "average_value": "Average Value",
        "duration": "Duration",
        "end": "End",
        "human_readable": "Human Readable",
        "percentage": "Percentage",
        "relative_end": "Relative End",
        "relative_start": "Relative Start",
        "start": "Start",
        "status": "Status",
        "status_count": "In Status",
        "value": "Value"
      },
      "content": {
        "calculated_based_on": "Calculated based on",
        "current_status_accumulated_time": "Current Status Accumulated Time",
        "data_unavailable": " There is currently no Lifecycle data for this Job.",
        "jobs_in_since": "Jobs in since",
        "legend_title": "Legend",
        "loading": "Loading Job Timelines....",
        "not_available": "N/A",
        "previous_status_accumulated_time": "Previous Status Accumulated Time",
        "title": "Job Lifecycle Component",
        "title_durations": "Historical Status Durations",
        "title_loading": "Loading",
        "title_transitions": "Transitions"
      },
      "errors": {
        "fetch": "Error getting Job Lifecycle Data"
      },
      "titles": {
        "dashboard": "Job Lifecycle",
        "top_durations": "Top Durations"
      }
    },
    "job_payments": {
      "buttons": {
        "create_short_link": "Generate Short Link",
        "goback": "Go Back",
        "proceedtopayment": "Proceed to Payment",
        "refundpayment": "Refund Payment"
      },
      "notifications": {
        "error": {
          "description": "An error has occurred processing the refund: {{message}}",
          "openingip": "Error connecting to IntelliPay service.",
          "title": "Error issuing refund"
        }
      },
      "titles": {
        "amount": "Amount",
        "dateOfPayment": "Date of Payment",
        "descriptions": "Payment Details",
        "hint": "Hint",
        "payer": "Payer",
        "payername": "Payer Name",
        "paymentid": "Payment Reference ID",
        "paymentnum": "Payment Number",
        "paymenttype": "Payment Type",
        "refundamount": "Refund Amount",
        "transactionid": "Transaction ID"
      }
    },
    "joblines": {
      "actions": {
        "assign_team": "Assign Team",
        "converttolabor": "Convert amount to Labor.",
        "dispatchparts": "Dispatch Parts ({{count}})",
        "new": "New Line",
        "revertprice": "Revert",
        "save_add_another": "Save & Add Another",
        "updatelocation": "Update Location"
      },
      "errors": {
        "creating": "Error encountered while creating job line.  {{message}}",
        "updating": "Error encountered updating job line. {{message}}"
      },
      "fields": {
        "act_price": "Retail Price",
        "act_price_before_ppc": "Original Part Price",
        "adjustment": "Adjustment",
        "ah_detail_line": "Mark as Detail Labor Line (Autohouse Only)",
        "alt_partno": "Alt Part #",
        "amount": "Amount",
        "assigned_team": "Team",
        "assigned_team_name": "Team {{name}}",
        "cost_only": "Cost Only",
        "create_ppc": "Create PPC?",
        "db_price": "List Price",
        "include_in_part_cnt": "Include in Parts Status Count",
        "lbr_types": {
          "LA1": "LA1",
          "LA2": "LA2",
          "LA3": "LA3",
          "LA4": "LA4",
          "LAA": "Aluminum",
          "LAB": "Body",
          "LAD": "Diagnostic",
          "LAE": "Electrical",
          "LAF": "Frame",
          "LAG": "Glass",
          "LAM": "Mechanical",
          "LAR": "Refinish",
          "LAS": "Structural",
          "LAU": "User Defined"
        },
        "line_desc": "Line Desc.",
        "line_ind": "S#",
        "line_kind": "Line Kind",
        "line_no": "Line #",
        "location": "Location",
        "mod_lb_hrs": "Hrs",
        "mod_lbr_ty": "Labor Type",
        "notes": "Notes",
        "oem_partno": "OEM  Part #",
        "op_code_desc": "Op Code Description",
        "part_qty": "Qty.",
        "part_type": "Part Type",
        "part_types": {
          "CCC": "CC Cleaning",
          "CCD": "CC Damage Waiver",
          "CCDR": "CC Daily Rate",
          "CCF": "CC Refuel",
          "CCM": "CC Mileage",
          "PAA": "Aftermarket",
          "PAC": "Rechromed",
          "PAE": "Existing",
          "PAG": "Glass",
          "PAL": "LKQ",
          "PAM": "Remanufactured",
          "PAN": "New/OEM",
          "PAO": "Other",
          "PAP": "OEM Partial",
          "PAR": "Recored",
          "PAS": "Sublet",
          "PASL": "Sublet (L)"
        },
        "profitcenter_labor": "Profit Center: Labor",
        "profitcenter_part": "Profit Center: Part",
        "prt_dsmk_m": "Line Discount/Markup $",
        "prt_dsmk_p": "Line Discount/Markup %",
        "status": "Status",
        "tax_part": "Tax Part",
        "total": "Total",
        "unq_seq": "Seq #"
      },
      "kinds": {
        "both": "Labor + Part",
        "fee": "Fee / Other",
        "labor": "Labor",
        "part": "Part"
      },
      "labels": {
        "adjustmenttobeadded": "Adjustment to be added: {{adjustment}}",
        "ah_detail_line_help": "Available for user-defined labor types (LA1–LA4, LAU).",
        "apply_preset": "Apply preset…",
        "billref": "Latest Bill",
        "bulk_location_help": "This will set the same location on all selected lines.",
        "convertedtolabor": "This line has been converted to labor. Ensure you adjust the profit center for the amount accordingly.",
        "cost_only_banner": "This line is skipped by totals and taxes but still appears in parts ordering and labor. It shows highlighted in orange on the estimate lines table.",
        "cost_only_help": "Cost only lines are excluded from the job totals but still show under parts and labor.",
        "discount_applied": "= {{amount}} applied to this line",
        "discount_markup": "Discount / Markup",
        "edit": "Edit Line",
        "excluded_from_totals": "Excluded from totals",
        "hours_required_hint": "Required while a labor type is set",
        "include_in_part_cnt_help": "Available when the retail price is $0.00.",
        "ioucreated": "IOU",
        "manuallineprice": "Manual lines are priced from the line's edit action, not this popover.",
        "new": "New Line",
        "nostatus": "No Status",
        "not_set_by_preset": "Not set by this preset",
        "preset_applied": "Preset applied — highlighted fields were filled by {{label}}; everything stays editable.",
        "presets": "Jobline Presets",
        "tax_part_help": "Include this line when calculating taxes."
      },
      "sections": {
        "fee": "Amount",
        "labor": "Labor",
        "line": "Line Details",
        "options": "Options",
        "parts": "Parts & Pricing"
      },
      "successes": {
        "created": "Job line created successfully.",
        "saved": "Job line saved.",
        "updated": "Job line updated successfully."
      },
      "validations": {
        "ahdetailonlyonuserdefinedtypes": "Detail line indicator can only be set for LA1, LA2, LA3, LA4, and LAU labor types.",
        "hrsrequirediflbrtyp": "Labor hours are required if a labor type is selected. Clear the labor type if there are no labor hours.",
        "requiredifparttype": "Required if a part type has been specified.",
        "zeropriceexistingpart": "This line cannot have any price since it uses an existing part."
      }
    },
    "jobs": {
      "actions": {
        "addDocuments": "Add Job Documents",
        "addNote": "Add Note",
        "addpayer": "Add Payer",
        "addtopartsqueue": "Add to Parts Queue",
        "removefrompartsqueue": "Remove from Parts Queue",
        "addtoproduction": "Add to Production",
        "addtoscoreboard": "Add to Scoreboard",
        "allocate": "Allocate",
        "autoallocate": "Auto Allocate",
        "changefilehandler": "Change Adjuster",
        "changelaborrate": "Change Labor Rate",
        "changestatus": "Change Status",
        "changestimator": "Change Estimator",
        "convert": "Convert",
        "convertwithoutearlyro": "Convert without Early RO",
        "createiou": "Create IOU",
        "deliver": "Deliver",
        "deliver_quick": "Quick Deliver",
        "dms": {
          "addpayer": "Add Payer",
          "createearlyro": "Create RR RO",
          "createnewcustomer": "Create New Customer",
          "findmakemodelcode": "Find Make/Model Code",
          "getmakes": "Get Makes",
          "labels": {
            "refreshallocations": "Refresh this component to see the DMS allocations."
          },
          "post": "Post",
          "refetchmakesmodels": "Refetch Make and Model Codes",
          "update_ro": "Update RO",
          "usegeneric": "Use Generic Customer",
          "useselected": "Use Selected Customer"
        },
        "dmsautoallocate": "DMS Auto Allocate",
        "export": "Export",
        "exportcustdata": "Export Customer Data",
        "exportselected": "Export Selected",
        "filterpartsonly": "Filter Parts Only",
        "generatecsi": "Generate CSI & Copy Link",
        "gotojob": "Go to Job",
        "intake": "Intake",
        "intake_quick": "Quick Intake",
        "manualnew": "Create New Job Manually",
        "mark": "Mark",
        "markasexported": "Mark as Exported",
        "markpstexempt": "Mark Job PST Exempt",
        "markpstexemptconfirm": "Are you sure you want to do this? To undo this,  you must manually update all PST rates.",
        "postbills": "Post Bills",
        "printCenter": "Print Center",
        "recalculate": "Recalculate",
        "reconcile": "Reconcile",
        "removefromproduction": "Remove from Production",
        "schedule": "Schedule",
        "sendcsi": "Send CSI",
        "sendpartspricechange": "Send Parts Price Change",
        "sendtodms": "Send to DMS",
        "sync": "Sync",
        "taxprofileoverride": "Override Tax Profile with Shop Configuration",
        "taxprofileoverride_confirm": "Are you sure you want to override the tax profile information? This cannot be undone without re-importing the job. ",
        "uninvoice": "Uninvoice",
        "unvoid": "Unvoid Job",
        "viewchecklist": "View Checklists",
        "viewdetail": "View Details"
      },
      "errors": {
        "addingtoproduction": "Error adding to production. {{error}}",
        "cannotintake": "Intake cannot be completed for this Job. It has either already been completed or the job is already here.",
        "closing": "Error closing Job. {{error}}",
        "creating": "Error encountered while creating job. {{error}}",
        "deleted": "Error deleting Job. {{error}}",
        "exporting": "Error exporting Job. {{error}}",
        "exporting-partner": "Unable to connect to partner application. Please ensure it is running and logged in.",
        "invalidjoblines": "Job has invalid job lines.",
        "invoicing": "Error invoicing Job. {{error}}",
        "missingjoblineids": "Missing job line IDs for job lines.",
        "noaccess": "This Job does not exist or you do not have access to it.",
        "nodamage": "No damage points on estimate.",
        "nodates": "No dates specified for this Job.",
        "nofinancial": "No financial data has been calculated yet for this job. Please save it again.",
        "nojobselected": "No Job is selected.",
        "noowner": "No owner associated.",
        "novehicle": "No vehicle associated.",
        "partspricechange": "Error sending parts price change. {{error}}.",
        "saving": "Error encountered while saving record.",
        "scanimport": "Error importing Job. {{message}}",
        "totalscalc": "Error while calculating new Job totals.",
        "updating": "Error while updating Job(s).  {{error}}",
        "validation": "Please ensure all fields are entered correctly.",
        "validationtitle": "Validation Error",
        "voiding": "Error voiding Job.  {{error}}"
      },
      "fields": {
        "active_tasks": "Active Tasks",
        "actual_completion": "Actual Completion",
        "actual_delivery": "Actual Delivery",
        "actual_in": "Actual In",
        "acv_amount": "ACV Amount",
        "adjustment_bottom_line": "Adjustments",
        "adjustmenthours": "Adjustment Hours",
        "admin_clerk": "Admin Clerk",
        "alt_transport": "Alt. Trans.",
        "area_of_damage_impact": {
          "10": "Left Front Side",
          "11": "Left Front Corner",
          "12": "Front",
          "13": "Rollover",
          "14": "Unknown",
          "15": "Total Loss",
          "16": "Non-collision",
          "25": "Hood",
          "26": "Deck-lid",
          "27": "Roof",
          "28": "Undercarriage",
          "34": "All Over",
          "01": "Right Front Corner",
          "02": "Right Front Side",
          "03": "Right Side",
          "04": "Right Rear Side",
          "05": "Right Rear Corner",
          "06": "Rear",
          "07": "Left Rear Corner",
          "08": "Left Rear Side",
          "09": "Left Side"
        },
        "auto_add_ats": "Automatically Add/Update ATS?",
        "ca_bc_pvrt": "PVRT",
        "ca_customer_gst": "Customer Portion of GST",
        "ca_gst_registrant": "GST Registrant",
        "category": "Category",
        "ccc": "CC Cleaning",
        "ccd": "CC Damage Waiver",
        "ccdr": "CC Daily Rate",
        "ccf": "CC Refuel",
        "ccm": "CC Mileage",
        "cieca_id": "CIECA ID",
        "cieca_pfl": {
          "lbr_adjp": "Labor Adjustment",
          "lbr_tax_in": "Tax Labor Indicator",
          "lbr_taxp": "Labor Tax Rate",
          "lbr_tx_in1": "Tax 1 Indicator",
          "lbr_tx_in2": "Tax 2 Indicator",
          "lbr_tx_in3": "Tax 3 Indicator",
          "lbr_tx_in4": "Tax 4 Indicator",
          "lbr_tx_in5": "Tax 5 Indicator"
        },
        "cieca_pfo": {
          "stor_t_in1": "Storage Tax 1 Indicator",
          "stor_t_in2": "Storage Tax 2 Indicator",
          "stor_t_in3": "Storage Tax 3 Indicator",
          "stor_t_in4": "Storage Tax 4 Indicator",
          "stor_t_in5": "Storage Tax 5 Indicator",
          "tow_t_in1": "Tow Tax 1 Indicator",
          "tow_t_in2": "Tow Tax 2 Indicator",
          "tow_t_in3": "Tow Tax 3 Indicator",
          "tow_t_in4": "Tow Tax 4 Indicator",
          "tow_t_in5": "Tow Tax 5 Indicator"
        },
        "claim_total": "Claim Total",
        "class": "Class",
        "clm_no": "Claim #",
        "clm_total": "Claim Total",
        "comment": "Comment",
        "customerowing": "Customer Owing",
        "date_estimated": "Date Estimated",
        "date_exported": "Exported",
        "date_invoiced": "Invoiced",
        "date_last_contacted": "Last Contacted Date",
        "date_lost_sale": "Lost Sale",
        "date_next_contact": "Next Contact Date",
        "date_open": "Open",
        "date_rentalresp": "Shop Rental Responsibility Start",
        "date_repairstarted": "Repairs Started",
        "date_scheduled": "Scheduled",
        "date_towin": "Towed In",
        "date_void": "Void",
        "ded_amt": "Deductible",
        "ded_note": "Deductible Note",
        "ded_status": "Deductible Status",
        "depreciation_taxes": "Betterment/Depreciation/Taxes",
        "dms": {
          "IsARCustomer": "AR Customer?",
          "address": "Customer Address",
          "advisor": "Advisor #",
          "amount": "Amount",
          "center": "Center",
          "control_type": {
            "account_number": "Account Number"
          },
          "cost": "Cost",
          "cost_dms_acctnumber": "Cost DMS Acct #",
          "customer": "Customer #",
          "dms_make": "DMS Make",
          "dms_model": "DMS Model",
          "dms_model_override": "Override DMS Make/Model",
          "dms_unsold": "New, Unsold Vehicle",
          "dms_wip_acctnumber": "Cost WIP DMS Acct #",
          "first_name": "First Name",
          "id": "DMS ID",
          "inservicedate": "In Service Date",
          "journal": "Journal #",
          "last_name": "Last Name",
          "lines": "Posting Lines",
          "make_override": "Make Override",
          "name1": "Customer Name",
          "payer": {
            "amount": "Amount",
            "control_type": "Control Type",
            "controlnumber": "Control Number",
            "dms_acctnumber": "DMS Account #",
            "name": "Payer Name",
            "payer_type": "Payer"
          },
          "rr_opcode": "RR OpCode",
          "rr_opcode_base": "Base",
          "rr_opcode_prefix": "Prefix",
          "rr_opcode_suffix": "Suffix",
          "sale": "Sale",
          "sale_dms_acctnumber": "Sale DMS Acct #",
          "story": "Story",
          "vinowner": "VIN Owner"
        },
        "dms_allocation": "DMS Allocation",
        "driveable": "Driveable",
        "employee_body": "Body",
        "employee_csr": "Customer Service Rep.",
        "employee_csr_writer": "Writer",
        "employee_prep": "Prep",
        "employee_refinish": "Refinish",
        "est_addr1": "Estimator Address",
        "est_co_nm": "Estimator Company",
        "est_co_nm_short": "Company",
        "est_ct_fn": "Estimator First Name",
        "est_ct_fn_short": "First Name",
        "est_ct_ln": "Estimator Last Name",
        "est_ct_ln_short": "Last Name",
        "est_ea": "Estimator Email",
        "est_ea_short": "Email",
        "est_ph1": "Estimator Phone #",
        "est_ph1_short": "Phone #",
        "estimate_approved": "Estimate Approved",
        "estimate_sent_approval": "Estimate Sent for Approval",
        "federal_tax_payable": "Federal Tax Payable",
        "federal_tax_rate": "Federal Tax Rate",
        "flat_rate_ats": "Flat Rate ATS?",
        "hit_and_run": "Hit and Run",
        "ins_addr1": "Insurance Co. Address",
        "ins_city": "Insurance Co. City",
        "ins_co_id": "Insurance Co. ID",
        "ins_co_nm": "Insurance Company Name",
        "ins_co_nm_short": "Ins.  Co.",
        "ins_ct_fn": "Adjuster First Name",
        "ins_ct_fn_short": "First Name",
        "ins_ct_ln": "Adjuster Last Name",
        "ins_ct_ln_short": "Last Name",
        "ins_ea": "Adjuster Email",
        "ins_ea_short": "Email",
        "ins_ph1": "Adjuster Phone #",
        "ins_ph1_short": "Phone #",
        "intake": {
          "label": "Label",
          "max": "Maximum",
          "min": "Minimum",
          "name": "Name",
          "required": "Required?",
          "type": "Type"
        },
        "invoice_final_note": "Note to Display on Final Invoice",
        "kmin": "Mileage In",
        "kmout": "Mileage Out",
        "la1": "LA1",
        "la2": "LA2",
        "la3": "LA3",
        "la4": "LA4",
        "laa": "Aluminum ",
        "lab": "Body",
        "labor_rate_desc": "Labor Rate Name",
        "lad": "Diagnostic",
        "lae": "Electrical",
        "laf": "Frame",
        "lag": "Glass",
        "lam": "Mechanical",
        "lar": "Refinish",
        "las": "Structural",
        "lau": "User Defined",
        "local_tax_rate": "Local Tax Rate",
        "loss_date": "Loss Date",
        "loss_desc": "Loss Description",
        "loss_of_use": "Loss of Use",
        "lost_sale_reason": "Lost Sale Reason",
        "ma2s": "2 Stage Paint",
        "ma3s": "3 Stage Paint",
        "mabl": "MABL?",
        "macs": "MACS?",
        "mahw": "Hazardous Waste",
        "mapa": "Paint Materials",
        "mash": "Shop Materials",
        "matd": "Tire Disposal",
        "materials": {
          "MAPA": "Paint Materials",
          "MASH": "Shop Materials",
          "cal_maxdlr": "Threshhold",
          "cal_opcode": "OP Codes",
          "mat_adjp": "Material Adjustment",
          "mat_taxp": "Material Tax Rate",
          "mat_tx_in1": "Tax 1 Indicator",
          "mat_tx_in2": "Tax 2 Indicator",
          "mat_tx_in3": "Tax 3 Indicator",
          "mat_tx_in4": "Tax 4 Indicator",
          "mat_tx_in5": "Tax 5 Indicator",
          "materials": "Profile - Materials",
          "tax_ind": "Tax Indicator"
        },
        "other_amount_payable": "Other Amount Payable",
        "owner": "Owner",
        "owner_owing": "Cust. Owes",
        "ownr_ea": "Email",
        "ownr_ph1": "Phone 1",
        "ownr_ph2": "Phone 2",
        "paa": "Aftermarket",
        "pac": "Rechromed",
        "pae": "Existing",
        "pag": "Glass",
        "pal": "LKQ",
        "pam": "Remanufactured",
        "pan": "OEM/New",
        "pao": "Other",
        "pap": "OEM Partial",
        "par": "Re-cored",
        "parts_tax_rates": {
          "prt_discp": "Discount %",
          "prt_mktyp": "Markup Type",
          "prt_mkupp": "Markup %",
          "prt_tax_in": "Tax Indicator",
          "prt_tax_rt": "Part Tax Rate",
          "prt_tx_in1": "Tax 1 Indicator",
          "prt_tx_in2": "Tax 2 Indicator",
          "prt_tx_in3": "Tax 3 Indicator",
          "prt_tx_in4": "Tax 4  Indicator",
          "prt_tx_in5": "Tax 5 Indicator",
          "prt_tx_ty1": "Parts Tax Type 1",
          "prt_type": "Part Type"
        },
        "partsstatus": "Parts Status",
        "pas": "Sublet",
        "pay_date": "Pay Date",
        "phoneshort": "PH",
        "po_number": "PO Number",
        "policy_no": "Policy #",
        "ponumber": "PO Number",
        "production_vars": {
          "note": "Production Note"
        },
        "qb_multiple_payers": {
          "amount": "Amount",
          "name": "Name"
        },
        "queued_for_parts": "Queued",
        "rate_ats": "ATS Rate",
        "rate_ats_flat": "ATS Flat Rate",
        "rate_la1": "LA1",
        "rate_la2": "LA2",
        "rate_la3": "LA3",
        "rate_la4": "LA4",
        "rate_laa": "Aluminum",
        "rate_lab": "Body",
        "rate_lad": "Diagnostic",
        "rate_lae": "Electrical",
        "rate_laf": "Frame",
        "rate_lag": "Glass",
        "rate_lam": "Mechanical",
        "rate_lar": "Refinish",
        "rate_las": "Structural",
        "rate_lau": "User Defined",
        "rate_ma2s": "2 Stage Paint",
        "rate_ma3s": "3 Stage Paint",
        "rate_mabl": "MABL??",
        "rate_macs": "MACS??",
        "rate_mahw": "Hazardous Waste",
        "rate_mapa": "Paint Materials",
        "rate_mash": "Shop Material",
        "rate_matd": "Tire Disposal",
        "referral_source_extra": "Other Referral Source",
        "referral_source_other": "",
        "referralsource": "Referral Source",
        "regie_number": "Registration #",
        "repairtotal": "Repair Total",
        "ro_number": "RO #",
        "scheduled_completion": "Scheduled Completion",
        "scheduled_delivery": "Scheduled Delivery",
        "scheduled_in": "Scheduled In",
        "selling_dealer": "Selling Dealer",
        "selling_dealer_contact": "Selling Dealer Contact",
        "servicecar": "Service Car",
        "servicing_dealer": "Servicing Dealer",
        "servicing_dealer_contact": "Servicing Dealer Contact",
        "special_coverage_policy": "Special Coverage Policy",
        "specialcoveragepolicy": "Special Coverage Policy",
        "state_tax_rate": "State Tax Rate",
        "status": "Job Status",
        "storage_payable": "Storage",
        "tax_lbr_rt": "Labor Tax Rate",
        "tax_levies_rt": "Levies Tax Rate",
        "tax_paint_mat_rt": "Paint Material Tax Rate",
        "tax_registration_number": "Tax Registration Number",
        "tax_shop_mat_rt": "Shop Material Tax Rate",
        "tax_str_rt": "Storage Tax Rate",
        "tax_sub_rt": "Sublet Tax Rate",
        "tax_tow_rt": "Towing Tax Rate",
        "tlos_ind": "Total Loss Indicator",
        "towin": "Tow In",
        "towing_payable": "Towing Payable",
        "unitnumber": "Unit #",
        "updated_at": "Updated At",
        "uploaded_by": "Uploaded By",
        "vehicle": "Vehicle"
      },
      "forms": {
        "admindates": "Administrative Dates",
        "appraiserinfo": "Estimator Info",
        "claiminfo": "Claim Information",
        "estdates": "Estimate Dates",
        "laborrates": "Labor Rates",
        "lossinfo": "Loss Information",
        "other": "Other",
        "repairdates": "Repair Dates",
        "scheddates": "Schedule Dates"
      },
      "labels": {
        "esignatures": "E-Signatures",
        "accountsreceivable": "Accounts Receivable",
        "act_price_ppc": "New Part Price",
        "actual_completion_inferred": "$t(jobs.fields.actual_completion) inferred using $t(jobs.fields.scheduled_completion).",
        "actual_delivery_inferred": "$t(jobs.fields.actual_delivery) inferred using $t(jobs.fields.scheduled_delivery).",
        "actual_in_inferred": "$t(jobs.fields.actual_in) inferred using $t(jobs.fields.scheduled_in).",
        "additionalpayeroverallocation": "You have allocated more than the sale of the Job to additional payers.",
        "additionaltotal": "Additional Total",
        "adjustmentrate": "Adjustment Rate",
        "adjustments": "Adjustments",
        "adminwarning": "Use the functionality on this page at your own risk.  You are responsible for any and all changes to your data.",
        "allocations": "Allocations",
        "alreadyaddedtoscoreboard": "Job has already been added to scoreboard. Saving will update the previous entry.",
        "alreadyclosed": "This Job has already been closed.",
        "appointmentconfirmation": "Send confirmation to customer?",
        "approved": "",
        "associationwarning": "Any changes to associations will require updating the data from the new parent record to the Job.",
        "audit": "Audit Trail",
        "available": "Available",
        "availablejobs": "Available Jobs",
        "ca_bc_pvrt": {
          "days": "Days",
          "rate": "PVRT Rate"
        },
        "ca_gst_all_if_null": "If the Job is marked as a \"GST Registrant\" and this value is set to $0,  the customer will be responsible for paying all of the GST by default. ",
        "calc_repair_days": "Calculated Repair Days",
        "calc_repair_days_tt": "This is the approximate number of days required to complete the repair according to the target touch time in your shop configuration (current set to {{target_touchtime}}).",
        "calc_scheuled_completion": "Calculate Scheduled Completion",
        "cards": {
          "customer": "Customer Information",
          "damage": "Area of Damage",
          "dates": "Dates",
          "documents": "Recent Documents",
          "estimator": "Estimator",
          "filehandler": "Adjuster",
          "insurance": "Insurance Details",
          "more": "More",
          "notes": "Notes",
          "parts": "Parts",
          "totals": "Totals",
          "vehicle": "Vehicle"
        },
        "changeclass": "Changing the Job's class can have fundamental impacts to already exported accounting items. Are you sure you want to do this?",
        "checklistcompletedby": "Checklist completed by {{by}} at {{at}}",
        "checklistdocuments": "Checklist Documents",
        "checklists": "Checklists",
        "cieca_pfl": "Profile - Labor",
        "cieca_pfo": "Profile - Other",
        "cieca_pft": "Profile - Taxes",
        "closeconfirm": "Are you sure you want to close this job? This cannot be easily undone.",
        "closejob": "Close Job {{ro_number}}",
        "closingperiod": "This Invoice Date is outside of the Closing Period.",
        "contracts": "CC Contracts",
        "convert": {
          "driveabledesc": "Vehicle can leave the shop under its own power once repairs are done.",
          "earlyrogatedesc": "This shop submits to Reynolds & Reynolds. Reserve an RO number below — the rest of this form unlocks once it's created.",
          "earlyrogatefooterhint": "Create the early RO above before converting.",
          "earlyrogatetitle": "Early RO required before converting",
          "gstdesc": "Customer is GST-registered — changes how tax is applied on this RO.",
          "requirements": "Conversion Requirements",
          "towindesc": "Vehicle arrived on a tow and cannot be driven in its current condition.",
          "vehiclestatus": "Vehicle & Billing Status"
        },
        "convertedtolabor": "Labor Line Adjustments",
        "cost": "Cost",
        "cost_Additional": "Cost - Additional",
        "cost_labor": "Cost - Labor",
        "cost_parts": "Cost - Parts",
        "cost_sublet": "Cost - Sublet",
        "costs": "Costs",
        "create": {
          "jobinfo": "Job Info",
          "newowner": "Create a new Owner instead. ",
          "newvehicle": "Create a new Vehicle Instead",
          "novehicle": "No vehicle (only for ROs to track parts/labor only work).",
          "ownerinfo": "Owner Info",
          "vehicleinfo": "Vehicle Info"
        },
        "createiouwarning": "Are you sure you want to create an IOU for these lines? A new RO will be created based on those lines for this customer.",
        "creating_new_job": "Creating new Job...",
        "deductible": {
          "stands": "Stands",
          "waived": "Waived"
        },
        "deleteconfirm": "Are you sure you want to delete this Job? This cannot be undone.",
        "deletedelivery": "Delete Delivery Checklist",
        "deleteintake": "Delete Intake Checklist",
        "deletewatchers": "Remove Watchers before deleting this Job.",
        "deliverchecklist": "Deliver Checklist",
        "difference": "Difference",
        "diskscan": "Scan Disk for Estimates",
        "dms": {
          "apexported": "AP export completed.  See logs for details.",
          "damageto": "Damage to $t(jobs.fields.area_of_damage_impact.{{area_of_damage}}).",
          "defaultstory": "B/S RO: {{ro_number}}. Owner: {{ownr_nm}}. Insurance Co: {{ins_co_nm}}. Claim/PO #: {{clm_po}}",
          "disablebillwip": "Cost and WIP for bills has been ignored per shop configuration.",
          "earlyro": {
            "created": "Early RO Created:",
            "fields": "Required fields:",
            "willupdate": "This will update the existing RO with full job data."
          },
          "invoicedatefuture": "Invoice date must be today or in the future for CDK posting.",
          "kmoutnotgreaterthankmin": "Mileage out must be greater than mileage in.",
          "logs": "Logs",
          "notallocated": "Not Allocated",
          "postingform": "Posting Form",
          "totalallocated": "Total Amount Allocated"
        },
        "documents": "Documents",
        "documents-images": "Images",
        "documents-other": "Other Documents",
        "duplicateconfirm": "Are you sure you want to duplicate this Job? Some elements of this Job will not be duplicated.",
        "emailaudit": "Email Audit Trail",
        "employeeassignments": "Employee Assignments",
        "esignature_imex": "ImEX Sign",
        "esignature_rome": "Rome Sign",
        "estimatelines": "Estimate Lines",
        "estimator": "Estimator",
        "existing_jobs": "Existing Jobs",
        "federal_tax_amt": "Federal Taxes",
        "gpdollars": "$ G.P.",
        "gppercent": "% G.P.",
        "hrs_claimed": "Hours Flagged",
        "hrs_total": "Hours Total",
        "importnote": "The Job was initially imported.",
        "inproduction": "In Production",
        "intakechecklist": "Intake Checklist",
        "iou": "IOU",
        "job": "Job Details",
        "jobcosting": "Job Costing",
        "jobtotals": "Job Totals",
        "labor_hrs": "B/P/T Hrs",
        "labor_rates_subtotal": "Labor Rates Subtotal",
        "laborallocations": "Labor Allocations",
        "labortotals": "Labor Totals",
        "lines": "Estimate Lines",
        "local_tax_amt": "Local Taxes",
        "mapa": "Paint Materials",
        "markforreexport": "Mark for Re-export",
        "mash": "Shop Materials",
        "masterbypass": "Master Bypass Password",
        "materials": {
          "mapa": ""
        },
        "missingprofileinfo": "This job has missing tax profile info. To ensure correct totals calculations, re-import the job.",
        "multipayers": "Additional Payers",
        "net_repairs": "Net Repairs",
        "notes": "Notes",
        "othertotal": "Other Totals",
        "outstanding_ar": "A balance is outstanding on this RO. Payments can still be entered when the job is closed. ",
        "outstanding_credit_memos": "Outstanding credit memos have not been entered against this job. Credit Memos may still be posted once the job is closed.",
        "outstanding_ppd": "There are outstanding PPDs that may not have been synced back to the estimate.",
        "outstanding_reconciliation_discrep": "At least one discrepancy is not $0. This may indicate that this job is not properly reconciled and should not be closed.",
        "outstanding_sublets": "There are sublet lines on the job which have not been marked as completed. ",
        "outstandinghours": "There are outstanding hours on the job that have not been paid or have been overpaid.",
        "override_header": "Override estimate header on import?",
        "ownerassociation": "Owner Association",
        "parts": "Parts",
        "parts_lines": "Parts Lines",
        "parts_received": "Parts Rec.",
        "parts_tax_rates": "Profile - Parts",
        "partsfilter": "Parts Only",
        "partssubletstotal": "Parts & Sublets Total",
        "partstotal": "Parts Total (ex. Taxes)",
        "performance": "Performance",
        "pimraryamountpayable": "Total Primary Payable",
        "plitooltips": {
          "billtotal": "The total amount of all bill lines that have been posted against this RO (not including credits, taxes, or labor adjustments).",
          "calculatedcreditsnotreceived": "The calculated credits not received is derived by subtracting the amount of credit memos entered from the <b>retail</b> total of returns created. This does not take into account whether the credit was marked as received. You can find more information <a href=\"https://help.imex.online/en/article/credits-not-received-changes-1jy9snw\" target=\"_blank\">here</a>.",
          "creditmemos": "The total <b>retail</b> amount of all returns created. This amount does not reflect credit memos that have been posted.",
          "creditsnotreceived": "This total reflects the total <b>retail</b> of parts returns lines that have not been explicitly marked as returned when posting a credit memo. You can learn more about this here <a href=\"https://help.imex.online/en/article/credits-not-received-changes-1jy9snw\" target=\"_blank\">here</a>. ",
          "discrep1": "If the discrepancy is not $0, you may have one of the following: <br/><br/>\n\n<ul>\n<li>Too many bills/bill lines that have been posted against this RO. Check to make sure every bill posted on this RO is correctly posted and assigned.</li>\n<li>You do not have the latest supplement imported, or, a supplement must be submitted and then imported.</li>\n<li>You have posted a bill line to labor.</li>\n</ul>\n<br/>\n<i>There may be additional issues not listed above that prevent this Job from reconciling.</i>",
          "discrep2": "If the discrepancy is not $0, you may have one of the following: <br/><br/>\n\n<ul>\n<li>Used an incorrect rate when deducting from labor.</li>\n<li>An outstanding imbalance higher in the reconciliation process.</li>\n</ul>\n<br/>\n<i>There may be additional issues not listed above that prevent this Job from reconciling.</i>",
          "discrep3": "If the discrepancy is not $0, you may have one of the following: <br/><br/>\n\n<ul>\n<li>A parts order return has not been created.</li>\n<li>An outstanding imbalance higher in the reconciliation process.</li>\n</ul>\n<br/>\n<i>There may be additional issues not listed above that prevent this Job from reconciling.</i>",
          "laboradj": "The sum of all bill lines that deducted from labor hours, rather than part prices.",
          "partstotal": "This is the total of all parts and sublet amounts on the vehicle (some of these may require an in-house invoice).<br/>\nItems such as shop and paint materials, labor online lines, etc. are not included in this total.",
          "totalreturns": "The total <b>retail</b> amount of returns created for this job."
        },
        "ppc": "This line contains a part price change.",
        "ppdnotexported": "PPDs not Exported",
        "profileadjustments": "Profile Disc./Mkup",
        "profitbypassrequired": "Minimum gross profit requirements have not been met.",
        "profits": "Job Profits",
        "prt_dsmk_total": "Line Item Adjustment",
        "rates": "Rates",
        "rates_subtotal": "All Rates Subtotal",
        "reconciliation": {
          "billlinestotal": "Bill Lines Total",
          "byassoc": "By Line Association",
          "byprice": "By Price",
          "clear": "Clear All",
          "discrepancy": "Discrepancy",
          "joblinestotal": "Job Lines Total",
          "multipleactprices": "${{act_price}} is the price for multiple job lines.",
          "multiplebilllines": "{{line_desc}} has 2 or more bill lines associated to it.",
          "multiplebillsforactprice": "Found more than 1 bill matching ${{act_price}} retail price.",
          "removedpartsstrikethrough": "Strike through lines represent parts that have been removed from the estimate. They are included for completeness of reconciliation."
        },
        "reconciliationheader": "Parts & Sublet Reconciliation",
        "relatedros": "Related ROs",
        "remove_from_ar": "Remove from AR",
        "returntotals": "Return Totals",
        "ro_guard": {
          "enforce_ar": "AR collection enforced.",
          "enforce_bills": "Bill discrepancy enforced.",
          "enforce_cm": "Credit memo entry enforced.",
          "enforce_labor": "Labor allocations enforced.",
          "enforce_ppd": "PPD sync enforced.",
          "enforce_profit": "Profit marginsenforced.",
          "enforce_sublet": "Sublet completion enforced.",
          "enforce_validation": "Master Bypass Required: {{message}}",
          "enforced": "This check has been enforced by your shop manager. Enter the master bypass password to close the Job."
        },
        "roguard": "RO Guard",
        "roguardwarnings": "RO Guard Warnings",
        "rosaletotal": "RO  Parts Total",
        "sale_additional": "Sales - Additional",
        "sale_labor": "Sales - Labor",
        "sale_parts": "Sales - Parts",
        "sale_sublet": "Sales - Sublet",
        "sales": "Sales",
        "savebeforeconversion": "You have unsaved changes on the Job.  Please save them before converting it. ",
        "scheduledinchange": "The scheduled in is based off the latest appointment. To change this date,  please schedule or reschedule the Job. ",
        "sent": "",
        "specialcoveragepolicy": "Special Coverage Policy Applies",
        "state_tax_amt": "Provincial/State Taxes",
        "subletsnotcompleted": "Outstanding Sublets",
        "subletstotal": "Sublets Total",
        "subtotal": "Subtotal",
        "supplementnote": "The Job had a supplement imported.",
        "suspended": "SUSPENDED",
        "suspense": "Suspense",
        "tasks": "Tasks",
        "threshhold": "Max Threshold: ${{amount}}",
        "total_cost": "Total Cost",
        "total_cust_payable": "Total Customer Amount Payable",
        "total_cust_payable_cash_discount": "$t(jobs.labels.total_cust_payable) (Cash Discounted)",
        "total_repairs": "Total Repairs",
        "total_repairs_cash_discount": "Total Repairs (Cash Discounted)",
        "total_sales": "Total Sales",
        "total_sales_tax": "Total Sales Tax",
        "totals": "Totals",
        "unvoidnote": "This Job was unvoided.",
        "update_scheduled_completion": "Update Scheduled Completion?",
        "vehicle_info": "Vehicle",
        "vehicleassociation": "Vehicle Association",
        "viewallocations": "View Allocations",
        "voidjob": "Are you sure you want to void this Job? This cannot be easily undone. ",
        "voidnote": "This Job was voided."
      },
      "successes": {
        "addedtoproduction": "Job added to production board.",
        "all_deleted": "{{count}} Jobs deleted successfully.",
        "closed": "Job closed successfully.",
        "converted": "Job converted successfully.",
        "created": "Job created successfully. Click to view.",
        "creatednoclick": "Job created successfully. ",
        "delete": "Job deleted successfully.",
        "deleted": "Job deleted successfully.",
        "duplicated": "Job duplicated successfully. ",
        "early_ro_created": "Early RO Created",
        "exported": "Job(s) exported successfully. ",
        "invoiced": "Job closed and invoiced successfully.",
        "ioucreated": "IOU created successfully.  Click to see.",
        "partsqueue": "Job added to parts queue.",
        "partsqueue_removed": "Job removed from parts queue.",
        "save": "Job saved successfully.",
        "savetitle": "Record saved successfully.",
        "supplemented": "Job supplemented successfully. ",
        "updated": "Job(s) updated successfully.",
        "voided": "Job voided successfully."
      }
    },
    "jobtimeline": {
      "categories": {
        "activity": "Activity",
        "documents": "Documents",
        "emails": "Emails",
        "esign": "E-Signatures",
        "messages": "Messages",
        "notes": "Notes",
        "parts": "Parts",
        "payments": "Payments",
        "status": "Status"
      },
      "empty": "No timeline events for this job yet.",
      "events": {
        "bill": "Bill {{invoice_number}} received from {{vendor}}",
        "document": "Document added: {{name}}",
        "email": "Email sent: {{subject}}",
        "esign_completed": "E-signature completed: {{title}}",
        "esign_sent": "E-signature requested: {{title}}",
        "message_image": "(Image attachment)",
        "message_received": "Text message received",
        "message_sent": "Text message sent",
        "message_system": "System message",
        "parts_dispatch": "Parts dispatch #{{number}} ({{count}} lines)",
        "parts_order": "Parts order #{{order_number}} placed with {{vendor}} ({{count}} lines)",
        "parts_return": "Parts return #{{order_number}} to {{vendor}} ({{count}} lines)",
        "parts_sublet": "Sublet order #{{order_number}} placed with {{vendor}} ({{count}} lines)",
        "payment": "Payment received ({{type}}) from {{payer}}",
        "quote_suffix": "(Quote)"
      },
      "filetypes": {
        "document": "Document",
        "image": "Image",
        "pdf": "PDF",
        "video": "Video"
      },
      "open": "Open",
      "showmore": "Show {{count}} more",
      "tab": "Timeline",
      "updated": "Updated"
    },
    "landing": {
      "bigfeature": {
        "subtitle": "Rome Online is built using world class technology by experts in the collision repair industry.  This translates to software that is tailor made for the unique challenges faced by repair facilities with no compromises. ",
        "title": "Bringing the latest technology to the automotive repair industry. "
      },
      "footer": {
        "company": {
          "about": "About Us",
          "contact": "Contact",
          "disclaimers": "Disclaimers",
          "name": "Company",
          "privacypolicy": "Privacy Policy"
        },
        "io": {
          "help": "Help",
          "name": "Rome Online",
          "status": "System Status"
        },
        "slogan": "Rome Technologies. is a technology leader in the collision repair industry. We specialize in creating collision repair management systems and bodyshop management systems that lower cycle times and promote efficiency."
      },
      "hero": {
        "button": "Learn More",
        "title": "Shop management reimagined."
      },
      "labels": {
        "features": "Features",
        "managemyshop": "Sign In",
        "pricing": "Pricing"
      },
      "pricing": {
        "basic": {
          "name": "Basic",
          "sub": "Best suited for shops looking to increase their volume."
        },
        "essentials": {
          "name": "Essentials",
          "sub": "Best suited for small and low volume shops."
        },
        "pricingtitle": "Features",
        "pro": {
          "name": "Pro",
          "sub": "Empower your shop with the tools to operate at peak capacity."
        },
        "title": "Features",
        "unlimited": {
          "name": "Unlimited",
          "sub": "Everything you need and more for the high volume shop."
        }
      }
    },
    "menus": {
      "currentuser": {
        "languageselector": "Language",
        "profile": "Profile"
      },
      "header": {
        "accounting": "Accounting",
        "accounting-payables": "Payables",
        "accounting-payments": "Payments",
        "accounting-receivables": "Receivables",
        "activejobs": "Active Jobs",
        "all_tasks": "All Tasks",
        "alljobs": "All Jobs",
        "allpayments": "All Payments",
        "availablejobs": "Available Jobs",
        "bills": "Bills",
        "courtesycars": "Courtesy Cars",
        "courtesycars-all": "All Courtesy Cars",
        "courtesycars-contracts": "Contracts",
        "courtesycars-newcontract": "New Contract",
        "create_task": "Create Task",
        "customers": "Customers",
        "dashboard": "Dashboard",
        "enterbills": "Enter Bills",
        "entercardpayment": "New Card Charge",
        "enterpayment": "Enter Payments",
        "entertimeticket": "Enter Time Tickets",
        "export": "Export",
        "export-logs": "Export Logs",
        "help": "Help",
        "home": "Home",
        "inventory": "Inventory",
        "jobs": "Jobs",
        "my_tasks": "My Tasks",
        "newjob": "Create New Job",
        "owners": "Owners",
        "parts-queue": "Parts Queue",
        "phonebook": "Phonebook",
        "productionboard": "Production Board - Visual",
        "productionlist": "Production Board - List",
        "readyjobs": "Ready Jobs",
        "recent": "Recent Items",
        "remoteassist": "Remote Assist",
        "reportcenter": "Report Center",
        "rescueme": "Rescue Me!",
        "rescuemezoho": "Remote Me In!",
        "schedule": "Schedule",
        "scoreboard": "Scoreboard",
        "search": {
          "bills": "Bills",
          "jobs": "Jobs",
          "owners": "Owners",
          "payments": "Payments",
          "phonebook": "Phonebook",
          "vehicles": "Vehicles"
        },
        "shiftclock": "Shift Clock",
        "shop": "My Shop",
        "shop_config": "Configuration",
        "shop_csi": "CSI",
        "shop_templates": "Templates",
        "shop_vendors": "Vendors",
        "tasks": "Tasks",
        "temporarydocs": "Temporary Documents",
        "timetickets": "Time Tickets",
        "ttapprovals": "Time Ticket Approvals",
        "vehicles": "Vehicles"
      },
      "jobsactions": {
        "admin": "Admin",
        "cancelallappointments": "Cancel all appointments",
        "closejob": "Close Job",
        "deletejob": "Delete Job",
        "duplicate": "Duplicate this Job",
        "duplicatenolines": "Duplicate this Job without Repair Data",
        "newcccontract": "Create Courtesy Car Contract",
        "sections": {
          "appointments": "Appointments",
          "billing": "Billing",
          "checklists": "Checklists & Delivery",
          "communication": "Customer & Communication",
          "job_tools": "Job Tools",
          "production": "Production",
          "time_tasks": "Time & Tasks"
        },
        "submit-for-testing": "Submit for Testing",
        "void": "Void Job"
      },
      "jobsdetail": {
        "claimdetail": "Claim Details",
        "dates": "Dates",
        "financials": "Financial Information",
        "general": "General",
        "insurance": "Insurance Information",
        "labor": "Labor",
        "lifecycle": "Lifecycle",
        "parts": "Parts",
        "partssublet": "Parts & Bills",
        "rates": "Rates",
        "repairdata": "Repair Data",
        "totals": "Totals"
      },
      "profilesidebar": {
        "profile": "My Profile",
        "shops": "My Shops"
      },
      "tech": {
        "assignedjobs": "Assigned Jobs",
        "claimtask": "Flag Hours",
        "dispatchedparts": "Dispatched Parts",
        "home": "Home",
        "jobclockin": "Job Clock In",
        "jobclockout": "Job Clock Out",
        "joblookup": "Job Lookup",
        "login": "Login",
        "logout": "Logout",
        "productionboard": "Production Visual",
        "productionlist": "Production List",
        "shiftclockin": "Shift Clock"
      }
    },
    "messaging": {
      "actions": {
        "back_to_conversations": "Back to conversations",
        "link": "Link to Job",
        "new": "New Conversation",
        "openchat": "Open Chat",
        "preview_media": "Preview full-size image"
      },
      "errors": {
        "download_image": "Error downloading image. {{message}}",
        "invalidphone": "The phone number is invalid.  Unable to open conversation. ",
        "no_consent": "This phone number has opted-out of Messaging.",
        "noattachedjobs": "No Jobs have been associated to this conversation. ",
        "save_image": "Error saving image to Job. {{message}}",
        "updatinglabel": "Error updating label. {{error}}"
      },
      "labels": {
        "active": "Active",
        "addlabel": "Add a label to this conversation.",
        "archive": "Archive",
        "archived": "Archived",
        "archived_read_only": "This conversation is archived and read-only.",
        "call": "Call",
        "conversation_list_mode": "Conversation list view",
        "earlier": "Earlier",
        "edit_label": "Edit Label",
        "live": "Live",
        "mark_unread": "Mark as unread",
        "more_jobs": "+{{count}} more",
        "maxtenimages": "You can only select up to a maximum of 10 images at a time.",
        "messaging": "Messaging",
        "no_consent": "Opted-out",
        "no_job_media": "No media found for this job.",
        "no_media_for_tag": "No media matches this tag.",
        "noallowtxt": "This customer has not indicated their permission to be messaged.",
        "nojobs": "Not associated to any Job.",
        "not_converted_abbreviation": "N/A",
        "nopush": "Polling Mode Enabled",
        "phonenumber": "Phone #",
        "presets": "Presets",
        "page_down": "Next page",
        "page_up": "Previous page",
        "recentonly": "Only your most recent 50 conversations will be shown here. If you are looking for an older conversation, find the related contact and click their phone number to view the conversation.",
        "ro_chip": "RO {{number}}",
        "save_to_job": "Save to Job documents",
        "scroll_bottom": "Scroll to bottom",
        "scroll_top": "Scroll to top",
        "search_conversations": "Search name, phone, label, or RO #",
        "select_conversation": "Select a conversation to view messages.",
        "select_job": "Select a Job",
        "empty_conversation": "Send a message to start the conversation.",
        "selectmedia": "Select Media",
        "send_hint_newline": "for a new line",
        "send_hint_send": "to send",
        "sentby": "Sent by {{by}} at {{time}}",
        "sms_segments": "{{used}} / {{max}} · {{count}} SMS segment(s)",
        "this_week": "This Week",
        "team_member": "Team member",
        "today": "Today",
        "typeamessage": "Send a message...",
        "unarchive": "Unarchive",
        "unarchive_to_continue": "Unarchive this conversation to send another message.",
        "unread_messages": "Unread messages: {{count}}",
        "unlink_job": "Unlink Job"
      },
      "presence": {
        "typing": "{{name}} is typing…",
        "typing_another_window": "You are typing in another window",
        "typing_many": "{{name}} and {{count}} others are typing…",
        "viewing": "{{name}} is viewing",
        "viewing_many": "{{name}} and {{count}} others are viewing"
      },
      "relative": {
        "days": "{{count}} d",
        "hours": "{{count}} h",
        "minutes": "{{count}} min",
        "months": "{{count}} mo",
        "now": "now",
        "years": "{{count}} y"
      },
      "render": {
        "conversation_list": "Conversation List"
      }
    },
    "notes": {
      "actions": {
        "actions": "Actions",
        "deletenote": "Delete Note",
        "edit": "Edit Note",
        "new": "New Note",
        "savetojobnotes": "Save to Job Notes"
      },
      "errors": {
        "inserting": "Error inserting note.  {{error}}"
      },
      "fields": {
        "createdby": "Created By",
        "critical": "Critical",
        "pinned": "Pinned",
        "private": "Private",
        "text": "Contents",
        "type": "Type",
        "types": {
          "customer": "Customer",
          "general": "General",
          "office": "Office",
          "paint": "Paint",
          "parts": "Parts",
          "shop": "Shop",
          "supplement": "Supplement",
          "estimator": "Estimator"
        },
        "updatedat": "Updated At"
      },
      "labels": {
        "addtorelatedro": "Add to Related ROs",
        "newnoteplaceholder": "Add a note...",
        "notetoadd": "Note to Add",
        "pinned_note": "Pinned Note",
        "systemnotes": "System Notes",
        "usernotes": "User Notes"
      },
      "successes": {
        "create": "Note created successfully.",
        "deleted": "Note deleted successfully.",
        "updated": "Note updated successfully."
      }
    },
    "notifications": {
      "actions": {
        "remove": "Remove"
      },
      "aria": {
        "toggle": "Toggle Watching Job"
      },
      "channels": {
        "app": "App",
        "email": "Email",
        "fcm": "Push"
      },
      "labels": {
        "add-watchers": "Add Watchers",
        "add-watchers-team": "Add Team Members",
        "auto-add": "Automatically watch Jobs I import",
        "auto-add-description": "",
        "auto-add-failure": "Something went wrong updating your auto watcher status.",
        "auto-add-off": "",
        "auto-add-on": "",
        "auto-add-success": "Auto watcher status successfully changed.",
        "employee-notification": "Notifications are disabled because you do not have an associated Employee record.",
        "employee-search": "Search for an Employee",
        "mark-all-read": "Mark All Read",
        "new-notification-title": "New Notification:",
        "no-watchers": "No Watchers",
        "notification-center": "Notification Center",
        "notification-popup-title": "Changes for Job #{{ro_number}}",
        "notification-settings-failure": "Error saving Notification Settings. {{error}}",
        "notification-settings-success": "Notification Settings saved successfully.",
        "notificationscenarios": "Job Notification Scenarios",
        "ro-number": "RO #{{ro_number}}",
        "save": "Save Scenarios",
        "scenario": "Scenario",
        "show-unread-only": "Show Unread Only",
        "teams-search": "Search for a Team",
        "unwatch": "Unwatch",
        "watch": "Watch",
        "watching-issue": "Watching"
      },
      "scenarios": {
        "alternate-transport-changed": "Alternate Transport Changed",
        "bill-posted": "Bill Posted",
        "critical-parts-status-changed": "Critical Parts Status Changed",
        "esign-document-completed": "E-Sign Document Completed",
        "esign-document-opened": "E-Sign Document Opened",
        "esign-document-upload-failed": "E-Sign Document Upload Failed",
        "intake-delivery-checklist-completed": "Intake or Delivery Checklist Completed",
        "job-added-to-production": "Job Added to Production",
        "job-assigned-to-me": "Job Assigned to Me",
        "job-status-change": "Job Status Changed",
        "new-media-added-reassigned": "New Media Added or Reassigned",
        "new-note-added": "New Note Added",
        "new-time-ticket-posted": "New Time Ticket Posted",
        "part-marked-back-ordered": "Part Marked Back Ordered",
        "payment-collected-completed": "Payment Collected / Completed",
        "schedule-dates-changed": "Schedule Dates Changed",
        "supplement-imported": "Supplement Imported",
        "tasks-updated-created": "Tasks Updated / Created"
      },
      "tooltips": {
        "job-watchers": "Job Watchers",
        "not-employee": "You need to be an employee to watch this job. Reach out to your admin to get set up!",
        "not-employee-notifications": "You must be an employee to receive notifications"
      }
    },
    "owner": {
      "labels": {
        "noownerinfo": "No owner information."
      }
    },
    "owners": {
      "actions": {
        "update": "Update Selected Records"
      },
      "errors": {
        "deleting": "Error deleting owner. {{error}}.",
        "noaccess": "The record does not exist or you do not have access to it.  ",
        "saving": "Error saving owner. {{error}}.",
        "selectexistingornew": "Select an existing owner record or create a new one. "
      },
      "fields": {
        "accountingid": "Accounting ID",
        "address": "Address",
        "name": "Name",
        "note": "Owner Note",
        "ownr_addr1": "Address",
        "ownr_addr2": "Address 2",
        "ownr_city": "City",
        "ownr_co_nm": "Owner Co. Name",
        "ownr_ctry": "Country",
        "ownr_ea": "Email",
        "ownr_fn": "First Name",
        "ownr_ln": "Last Name",
        "ownr_ph1": "Phone 1",
        "ownr_ph2": "Phone 2",
        "ownr_st": "Province/State",
        "ownr_title": "Title",
        "ownr_zip": "Zip/Postal Code",
        "preferred_contact": "Preferred Contact Method",
        "tax_number": "Tax Number"
      },
      "forms": {
        "address": "Address",
        "contact": "Contact Information",
        "name": "Owner Details"
      },
      "labels": {
        "cell": "Cell",
        "create_new": "Create a new owner record.",
        "deleteconfirm": "Are you sure you want to delete this owner? This cannot be undone.",
        "email": "Email",
        "existing_owners": "Existing Owners",
        "fromclaim": "Current Claim",
        "fromowner": "Historical Owner Record",
        "home": "Home",
        "other": "Other",
        "phone": "Phone",
        "relatedjobs": "Related Jobs",
        "sms": "SMS",
        "updateowner": "Update Owner",
        "work": "Work"
      },
      "successes": {
        "delete": "Owner deleted successfully.",
        "save": "Owner saved successfully."
      }
    },
    "parts": {
      "actions": {
        "order": "Order Parts",
        "orderinhouse": "Order as In House"
      },
      "labels": {
        "view_counts_only": "View Parts Counts Only",
        "view_timestamps": "Show timestamps"
      }
    },
    "parts_dispatch": {
      "actions": {
        "accept": "Accept"
      },
      "errors": {
        "accepting": "Error accepting parts dispatch. {{error}}",
        "creating": "Error dispatching parts. {{error}}"
      },
      "fields": {
        "number": "Number",
        "percent_accepted": "% Accepted"
      },
      "labels": {
        "notyetdispatched": "This part has not been dispatched.",
        "parts_dispatch": "Parts Dispatch"
      }
    },
    "parts_dispatch_lines": {
      "fields": {
        "accepted_at": "Accepted At"
      }
    },
    "parts_orders": {
      "actions": {
        "backordered": "Mark Backordered",
        "create_return": "Create Return",
        "place_order": "Place Order",
        "receive": "Receive",
        "receivebill": "Receive Bill",
        "save_quote": "Save Quote"
      },
      "errors": {
        "associatedbills": "This parts order cannot",
        "backordering": "Error backordering part {{message}}.",
        "creating": "Error encountered when creating parts order. ",
        "oec": "Error creating EMS files for parts order. {{error}}",
        "saving": "Error saving parts order.  {{error}}.",
        "updating": "Error updating parts order/parts order line. {{error}}."
      },
      "fields": {
        "act_price": "Price",
        "backordered_eta": "B.O. ETA",
        "backordered_on": "B.O. On",
        "cm_received": "CM Received?",
        "comments": "Comments",
        "cost": "Cost",
        "db_price": "List Price",
        "deliver_by": "Deliver By",
        "job_line_id": "Job Line Id",
        "line_desc": "Line Description",
        "line_remarks": "Remarks",
        "lineremarks": "Line Remarks",
        "oem_partno": "Part #",
        "order_date": "Order Date",
        "order_number": "Order Number",
        "orderedby": "Ordered By",
        "part_type": "Type",
        "quantity": "Qty.",
        "return": "Return",
        "returned_on": "Returned On",
        "returnedby": "Returned By",
        "status": "Status"
      },
      "labels": {
        "all": "All",
        "allpartsto": "All Parts Location",
        "awaitingcm": "Awaiting CM",
        "backordered": "Backordered",
        "cmreceivedstate": "CM Received",
        "cmreceivedsummary": "{{received}} of {{total}} CMs received",
        "confirmdelete": "Are you sure you want to delete this item? It cannot be recovered.  Job line statuses will not be updated and may require manual review. ",
        "cost_from_vendor_discount": "No job line cost yet - from vendor discount ({{percent}}%)",
        "creditingbill": "Crediting Bill",
        "customdiscount": "Custom Discount",
        "custompercent": "Custom %",
        "email": "Send by Email",
        "inthisorder": "Parts in this Order",
        "inthisreturn": "Parts in this Return",
        "is_quote": "Parts Quote?",
        "is_quote_help": "Save as a quote. Job lines are marked Quote instead of Ordered — works with any output, not just EMS.",
        "mark_as_received": "Mark as Received?",
        "newpartsorder": "New Parts Order",
        "notyetordered": "This part has not yet been ordered.",
        "oec": "Order via EMS",
        "onthisreturn": "Parts on this Return",
        "order_type": "Order Type",
        "orderhistory": "Order History",
        "overdue": "Overdue",
        "overduecount": "{{count}} line(s) overdue",
        "parts_order": "Parts Order",
        "parts_orders": "Parts Orders",
        "parts_returns": "Parts Returns",
        "price_discount_applied": "{{percent}}% off",
        "print": "Show Printed Form",
        "quickdiscount": "Quick Discount",
        "quote": "Quote",
        "quote_banner": "This order is created with Quote status. Parts are not marked as ordered until the quote is converted.",
        "receive": "Receive Parts Order",
        "removefrompartsqueue": "Unqueue from Parts Queue?",
        "removefrompartsqueue_help": "Remove this job from the parts queue when the order is created.",
        "returnpartsorder": "Return Parts Order",
        "sublet_order": "Sublet Order",
        "summary_cost": "cost {{cost}}",
        "summary_lines": "{{count}} line(s) · {{qty}} pcs",
        "vendorcontact": "Vendor Contact"
      },
      "sections": {
        "options": "Options",
        "order": "Order Details",
        "output": "Send As",
        "return": "Return Details"
      },
      "successes": {
        "created": "Parts order created successfully. ",
        "line_updated": "Parts return line updated.",
        "received": "Parts order received.",
        "return_created": "Parts return created successfully."
      },
      "validations": {
        "atleastoneline": "Add at least one line before saving."
      }
    },
    "payments": {
      "actions": {
        "generatepaymentlink": "Generate Payment Link"
      },
      "errors": {
        "exporting": "Error exporting payment(s). {{error}}",
        "exporting-partner": "Error exporting to partner. Please check the partner interaction log for more errors.",
        "inserting": "Error inserting payment. {{error}}"
      },
      "fields": {
        "amount": "Amount",
        "created_at": "Created At",
        "date": "Payment Date",
        "exportedat": "Exported At",
        "memo": "Memo",
        "payer": "Payer",
        "paymentnum": "Payment Number",
        "stripeid": "Stripe ID",
        "transactionid": "Transaction ID",
        "type": "Type"
      },
      "labels": {
        "balance": "Balance",
        "ca_bc_etf_table": "ICBC EFT Table Converter",
        "customer": "Customer",
        "edit": "Edit Payment",
        "electronicpayment": "Use Electronic Payment Processing?",
        "external": "External",
        "findermodal": "ICBC Payment Finder",
        "insurance": "Insurance",
        "markexported": "Mark Exported",
        "markforreexport": "Mark for Re-export",
        "new": "New Payment",
        "signup": "Please contact support to sign up for electronic payments.",
        "smspaymentreminder": "This is {{shopname}} reminding you about your balance of {{amount}}. To pay, click the following link {{payment_link}}.",
        "title": "Payments",
        "totalpayments": "Total Payments"
      },
      "successes": {
        "exported": "Payment(s) exported successfully.",
        "markexported": "Payment(s) marked exported.",
        "markreexported": "Payment marked for re-export successfully",
        "payment": "Payment created successfully. ",
        "paymentupdate": "Payment updated successfully. ",
        "stripe": "Credit card transaction charged successfully."
      }
    },
    "phonebook": {
      "actions": {
        "new": "New Phonebook Entry"
      },
      "errors": {
        "adding": "Error adding phonebook entry.  {{error}}",
        "saving": "Error saving phonebook entry. {{error}}"
      },
      "fields": {
        "address1": "Street 1",
        "address2": "Street 2",
        "category": "Category",
        "city": "City",
        "company": "Company",
        "country": "Country",
        "email": "Email",
        "fax": "Fax",
        "firstname": "First Name",
        "lastname": "Last Name",
        "phone1": "Phone 1",
        "phone2": "Phone 2",
        "state": "Province/State"
      },
      "labels": {
        "entry": "Phonebook Entry",
        "noneselected": "No phone book entry selected. ",
        "onenamerequired": "At least one name related field is required.",
        "sections": {
          "address": "Address",
          "communication": "Communication",
          "identity": "Identity",
          "location": "Location"
        },
        "vendorcategory": "Vendor"
      },
      "successes": {
        "added": "Phonebook entry added successfully. ",
        "deleted": "Phonebook entry deleted successfully. ",
        "saved": "Phonebook entry saved successfully. "
      }
    },
    "printcenter": {
      "appointments": {
        "appointment_confirmation": "Appointment Confirmation"
      },
      "banners": {
        "esignature_promo": "Tired of getting paper signatures? Try {{app}} today.",
        "esignature_signup_link": "Sign up",
        "esignature_signup_tooltip": "Before signing up, confirm the person completing the agreement is authorized to sign for the business and approve the monthly agreement starting next billing cycle. Current pricing and terms are shown on the form."
      },
      "bills": {
        "inhouse_invoice": "In House Invoice"
      },
      "courtesycarcontract": {
        "courtesy_car_contract": "Courtesy Car Contract",
        "courtesy_car_impound": "Impound Charges",
        "courtesy_car_inventory": "Courtesy Car Inventory",
        "courtesy_car_terms": "Courtesy Car Terms"
      },
      "errors": {
        "nocontexttype": "No context type set."
      },
      "jobs": {
        "3rdpartyfields": {
          "addr1": "Address 1",
          "addr2": "Address 2",
          "addr3": "Address 3",
          "address": "Address",
          "amounts": "Amounts",
          "attn": "Attention",
          "city": "City",
          "custgst": "Customer Portion of GST",
          "ded_amt": "Deductible",
          "delivery": "Delivery",
          "depreciation": "Depreciation",
          "location": "Location",
          "other": "Other",
          "payer": "Choose Payer",
          "payeralert": "Choose either a vendor or an insurance company. Selecting one will disable the other.",
          "payerhint": "Select the third-party payer first, then confirm or adjust the address and invoice amounts.",
          "payerrequired": "Select a vendor or an insurance company.",
          "ponumber": "PO Number",
          "reference": "Reference",
          "refnumber": "Reference Number",
          "selectinsurance": "Select an insurance company",
          "selectvendor": "Select a vendor",
          "sendtype": "Send by",
          "state": "Province/State",
          "zip": "Postal Code/Zip"
        },
        "3rdpartypayer": "Invoice to Third Party Payer",
        "ab_proof_of_loss": "AB - Proof of Loss",
        "appointment_confirmation": "Appointment Confirmation",
        "appointment_reminder": "Appointment Reminder",
        "casl_authorization": "CASL Authorization",
        "committed_timetickets_ro": "Committed Time Tickets",
        "coversheet_landscape": "Coversheet (Landscape)",
        "coversheet_portrait": "Coversheet Portrait",
        "csi_invitation": "CSI Invitation",
        "csi_invitation_action": "CSI Invite",
        "diagnostic_authorization": "Diagnostic Authorization",
        "dms_posting_sheet": "DMS Posting Sheet",
        "envelope_return_address": "#10 Envelope Return Address Label",
        "estimate": "Estimate Only",
        "estimate_detail": "Estimate Details",
        "estimate_followup": "Estimate Followup",
        "express_repair_checklist": "Express Repair Checklist",
        "filing_coversheet_landscape": "Filing Coversheet (Landscape)",
        "filing_coversheet_portrait": "Filing Coversheet (Portrait)",
        "final_invoice": "Final Invoice",
        "fippa_authorization": "FIPPA Authorization",
        "folder_label_multiple": "Folder Label - Multi",
        "glass_express_checklist": "Glass Express Checklist",
        "guarantee": "Repair Guarantee",
        "individual_job_note": "RO Job Note",
        "invoice_customer_payable": "Invoice (Customer Payable)",
        "invoice_total_payable": "Invoice (Total Payable)",
        "iou_form": "IOU Form",
        "job_costing_ro": "Job Costing",
        "job_lifecycle_ro": "Job Lifecycle",
        "job_notes": "Job Notes",
        "job_tasks": "Job Tasks",
        "key_tag": "Key Tag",
        "labels": {
          "count": "Count",
          "labels": "Labels",
          "position": "Starting Position"
        },
        "lag_time_ro": "Lag Time",
        "mechanical_authorization": "Mechanical Authorization",
        "mpi_animal_checklist": "MPI - Animal Checklist",
        "mpi_eglass_auth": "MPI - eGlass Auth",
        "mpi_final_acct_sheet": "MPI - Final Accounting Sheet (Direct Repair)",
        "mpi_final_repair_acct_sheet": "MPI - Final Accounting Sheet",
        "paint_grid": "Paint Grid",
        "parts_dispatch": "Parts Dispatch",
        "parts_invoice_label_single": "Parts Label Single",
        "parts_label_multiple": "Parts Label - Multi",
        "parts_label_single": "Parts Label - Single",
        "parts_list": "Parts List",
        "parts_order": "Parts Order Confirmation",
        "parts_order_confirmation": "",
        "parts_order_history": "Parts Order History",
        "parts_return_slip": "Parts Return Slip",
        "payment_receipt": "Payment Receipt",
        "payment_request": "Payment Request",
        "payments_by_job": "Job Payments",
        "purchases_by_ro_detail": "Purchases - Detail",
        "purchases_by_ro_summary": "Purchases - Summary",
        "qc_sheet": "Quality Control Sheet",
        "rental_reservation": "Rental Reservation",
        "ro_totals": "RO Totals",
        "ro_with_description": "RO Summary with Descriptions",
        "sgi_certificate_of_repairs": "SGI - Certificate of Repairs",
        "sgi_windshield_auth": "SGI - Windshield Authorization",
        "stolen_recovery_checklist": "Stolen Recovery Checklist",
        "sublet_order": "Sublet Order",
        "supplement_request": "Supplement Request",
        "thank_you_ro": "Thank You Letter",
        "thirdpartypayer": "Third Party Payer",
        "timetickets_ro": "Time Tickets",
        "vehicle_check_in": "Vehicle Intake",
        "vehicle_delivery_check": "Vehicle Delivery Checklist",
        "window_tag": "Window Tag",
        "window_tag_sublet": "Window Tag - Sublet",
        "work_authorization": "Work Authorization",
        "worksheet_by_line_number": "Worksheet by Line Number",
        "worksheet_sorted_by_operation": "Worksheet by Operation",
        "worksheet_sorted_by_operation_no_hours": "Worksheet by Operation (No Hours)",
        "worksheet_sorted_by_operation_part_type": "Worksheet by Operation & Part Type",
        "worksheet_sorted_by_operation_type": "Worksheet by Operation Type",
        "worksheet_sorted_by_team": "Worksheet by Team"
      },
      "labels": {
        "groups": {
          "authorization": "Authorization",
          "financial": "Financial",
          "post": "Post-Production",
          "pre": "Pre-Production",
          "ro": "Repair Order",
          "worksheet": "Worksheets"
        },
        "misc": "Miscellaneous Documents",
        "repairorder": "Repair Order Related",
        "reportcentermodal": "Report Center",
        "speedprint": "Speed Print",
        "title": "Print Center"
      },
      "payments": {
        "ca_bc_etf_table": "ICBC EFT Table",
        "exported_payroll": "Payroll Table"
      },
      "special": {
        "attendance_detail_csv": "Attendance Table"
      },
      "subjects": {
        "jobs": {
          "individual_job_note": "Job Note RO: {{ro_number}}",
          "parts_dispatch": "Parts Dispatch RO: {{ro_number}}",
          "parts_order": "Parts Order PO: {{ro_number}} - {{name}}",
          "parts_return_slip": "Parts Return PO: {{ro_number}} - {{name}}",
          "sublet_order": "Sublet Order PO: {{ro_number}} - {{name}}"
        }
      },
      "vendors": {
        "purchases_by_vendor_detailed": "Purchases by Vendor - Detailed",
        "purchases_by_vendor_summary": "Purchases by Vendor - Summary"
      }
    },
    "production": {
      "actions": {
        "addcolumns": "Add Columns",
        "bodypriority-clear": "Clear Body Priority",
        "bodypriority-set": "Set Body Priority",
        "detailpriority-clear": "Clear Detail Priority",
        "detailpriority-set": "Set Detail Priority",
        "paintpriority-clear": "Clear Paint Priority",
        "paintpriority-set": "Set Paint Priority",
        "remove": "Remove from Production",
        "removecolumn": "Remove Column",
        "saveconfig": "Save Configuration",
        "saveprofile": "Save Profile",
        "suspend": "Suspend",
        "unsuspend": "Unsuspend"
      },
      "constants": {
        "main_profile": "Default"
      },
      "errors": {
        "boardupdate": "Error encountered updating Job. {{message}}",
        "name_exists": "A Profile with this name already exists. Please choose a different name.",
        "name_required": "Profile name is required.",
        "removing": "Error removing from production board. {{error}}",
        "settings": "Error saving board settings: {{error}}"
      },
      "labels": {
        "actual_in": "Actual In",
        "addnewprofile": "Add New Profile",
        "alert": "Alert",
        "alertoff": "Remove alert from Job",
        "alerton": "Add alert to Job",
        "alerts": "Alerts",
        "ats": "Alternative Transportation",
        "bodyhours": "B",
        "bodypriority": "B/P",
        "bodyshop": {
          "labels": {
            "qbo_departmentid": "QBO Department ID",
            "qbo_usa": "QBO USA"
          }
        },
        "boardprofiles": "Board Profiles",
        "card_size": "Card Size",
        "cardcolor": "Colored Cards",
        "cardsettings": "Card Settings",
        "click_for_statuses": "Click to view parts statuses",
        "clm_no": "Claim Number",
        "color_by": "Color By",
        "comment": "Comment",
        "compact": "Compact Cards",
        "detailpriority": "D/P",
        "employeeassignments": "Employee Assignments",
        "employeesearch": "Employee Search",
        "estimator": "Estimator",
        "horizontal": "Horizontal",
        "ins_co_nm": "Insurance Company Name",
        "jobdetail": "Job Details",
        "kiosk_mode": "Kiosk Mode",
        "laborhrs": "Labor Hours",
        "legend": "Legend:",
        "model_info": "Vehicle Info",
        "note": "Production Note",
        "off": "Off",
        "on": "On",
        "orientation": "Board Orientation",
        "ownr_nm": "Customer Name",
        "paintpriority": "P/P",
        "partsreceived": "Parts Received",
        "partsstatus": "Parts Status",
        "production_note": "Production Note",
        "refinishhours": "R",
        "scheduled_completion": "Scheduled Completion",
        "selectview": "Select a View",
        "stickyheader": "Sticky Header (BETA)",
        "sublets": "Sublets",
        "subtotal": "Subtotal",
        "tall": "Tall",
        "tasks": "Tasks",
        "totalhours": "Total Hrs ",
        "touchtime": "T/T",
        "unassigned": "Unassigned",
        "vertical": "Vertical",
        "viewname": "View Name",
        "wide": "Wide"
      },
      "options": {
        "color_body": "Body Technician",
        "color_insurance": "Insurance Company",
        "color_none": "None",
        "color_prep": "Prep Technician",
        "color_refinish": "Refinish Technician",
        "color_severity": "Job Size / Severity",
        "color_writer": "Writer / CSR",
        "horizontal": "Horizontal",
        "large": "Large",
        "medium": "Medium",
        "small": "Small",
        "vertical": "Vertical"
      },
      "settings": {
        "board_settings": "Board Settings",
        "filters": {
          "actual_in_range": "Actual In",
          "alt_transport": "Alternative Transportation",
          "any": "Any",
          "any_date": "Any Date",
          "custom_range": "Custom Range",
          "md_estimators": "Estimators",
          "md_ins_cos": "Insurance Companies",
          "max": "Max",
          "min": "Min",
          "no_status": "No Status",
          "part_statuses": "Parts Statuses",
          "parts_received": "Parts Received",
          "parts_received_fully_received": "Fully Received",
          "parts_received_has_parts": "Has Parts",
          "parts_received_missing_received": "Missing Received Parts",
          "parts_received_no_parts": "No Parts",
          "parts_received_partially_received": "Partially Received",
          "production_note": "Production Note",
          "scheduled_completion_range": "Scheduled Completion",
          "sublets": "Sublets",
          "subtotal_range": "Subtotal",
          "tasks": "Tasks",
          "technicians": "Technicians / Employees",
          "this_month": "This Month",
          "this_quarter": "This Quarter",
          "this_week": "This Week",
          "this_year": "This Year",
          "vehicle_makes": "Vehicle Makes",
          "with": "With",
          "without": "Without",
          "writers": "Writers / CSRs"
        },
        "filters_title": "Filters",
        "information": "Information",
        "layout": "Layout",
        "statistics": {
          "exclude_suspended": "Exclude Suspended Jobs",
          "jobs_in_production": "Vehicles in Production",
          "tasks_in_production": "Tasks in Production",
          "tasks_in_view": "Tasks in View",
          "tasks_on_board": "Tasks on Board",
          "total_amount_in_production": "Dollars in Production",
          "total_amount_in_view": "Dollars in View",
          "total_amount_on_board": "Dollars on Board",
          "total_hours_in_production": "Hours in Production",
          "total_hours_in_view": "Hours in View",
          "total_hours_on_board": "Hours on Board",
          "total_jobs_in_view": "Vehicles in View",
          "total_jobs_on_board": "Vehicles on Board",
          "total_lab_in_production": "Body Hours in Production",
          "total_lab_in_view": "Body Hours in View",
          "total_lab_on_board": "Body Hours on Board",
          "total_lar_in_production": "Refinish Hours in Production",
          "total_lar_in_view": "Refinish Hours in View",
          "total_lar_on_board": "Refinish Hours on Board"
        },
        "statistics_title": "Statistics"
      },
      "statistics": {
        "currency_symbol": "$",
        "hours": "Hours",
        "jobs": "Jobs",
        "jobs_in_production": "Vehicles in Production",
        "tasks": "Tasks",
        "tasks_in_production": "Tasks in Production",
        "tasks_in_view": "Tasks in View",
        "tasks_on_board": "Tasks on Board",
        "total_amount_in_production": "Dollars in Production",
        "total_amount_in_view": "Dollars in View",
        "total_amount_on_board": "Dollars on Board",
        "total_hours_in_production": "Hours in Production",
        "total_hours_in_view": "Hours in View",
        "total_hours_on_board": "Hours on Board",
        "total_jobs_in_view": "Vehicles in View",
        "total_jobs_on_board": "Vehicles on Board",
        "total_lab_in_production": "Body Hours in Production",
        "total_lab_in_view": "Body Hours in View",
        "total_lab_on_board": "Body Hours on Board",
        "total_lar_in_production": "Refinish Hours in Production",
        "total_lar_in_view": "Refinish Hours in View",
        "total_lar_on_board": "Refinish Hours on Board",
        "vehicles": "Vehicles"
      },
      "successes": {
        "removed": "Job removed from production."
      }
    },
    "profile": {
      "errors": {
        "state": "Error reading page state.  Please refresh."
      },
      "labels": {
        "activeshop": "Active Shop"
      },
      "successes": {
        "updated": "Profile updated successfully."
      }
    },
    "reportcenter": {
      "actions": {
        "generate": "Generate"
      },
      "labels": {
        "advanced_filters": "Advanced Filters and Sorters",
        "advanced_filters_false": "False",
        "advanced_filters_filter_field": "Field",
        "advanced_filters_filter_operator": "Operator",
        "advanced_filters_filter_value": "Value",
        "advanced_filters_filters": "Filters",
        "advanced_filters_hide": "Hide",
        "advanced_filters_show": "Show",
        "advanced_filters_sorter_direction": "Direction",
        "advanced_filters_sorter_field": "Field",
        "advanced_filters_sorters": "Sorters",
        "advanced_filters_true": "True",
        "dates": "Dates",
        "employee": "Employee",
        "filterson": "Filters on {{object}}: {{field}}",
        "generateasemail": "Generate as Email?",
        "groups": {
          "customers": "Customers",
          "jobs": "Jobs & Costing",
          "payroll": "Payroll",
          "purchases": "Purchases",
          "sales": "Sales"
        },
        "key": "Report",
        "objects": {
          "appointments": "Appointments",
          "bills": "Bills",
          "csi": "CSI",
          "exportlogs": "Export Logs",
          "jobs": "Jobs",
          "parts_orders": "Parts Orders",
          "payments": "Payments",
          "scoreboard": "Scoreboard",
          "tasks": "Tasks",
          "timetickets": "Timetickets"
        },
        "vendor": "Vendor"
      },
      "production_search": {
        "action_csr": "CSR",
        "action_technician": "Technician",
        "action_writer": "Writer",
        "hints": {
          "close": "close",
          "navigate": "navigate",
          "select": "select"
        },
        "noresults": "No matches for \"{{search}}\"",
        "placeholder": "Search reports, employees, categories, statuses...",
        "scope_all": "All",
        "scope_category": "Category",
        "scope_employees": "Employees",
        "scope_reports": "Reports",
        "scope_status": "Status",
        "section_employees": "Employees",
        "section_reports": "Reports"
      },
      "templates": {
        "adp_payroll_flat": "ADP Payroll - Flat Rate",
        "adp_payroll_straight": "ADP Payroll - Straight Time",
        "anticipated_revenue": "Anticipated Revenue",
        "ar_aging": "AR Aging",
        "attendance_detail": "Attendance (All Employees)",
        "attendance_employee": "Employee Attendance",
        "attendance_summary": "Attendance Summary (All Employees)",
        "committed_timetickets": "Committed Time Tickets",
        "committed_timetickets_employee": "Committed Employee Time Tickets",
        "committed_timetickets_summary": "Committed Time Tickets Summary",
        "credits_not_received_date": "Credits not Received by Date",
        "credits_not_received_date_vendorid": "Credits not Received by Vendor",
        "csi": "CSI Responses",
        "customer_list": "Customer List",
        "customer_list_excel": "Customer List - Excel",
        "cycle_time_analysis": "Cycle Time Analysis",
        "estimates_written_converted": "Estimates Written/Converted",
        "estimator_detail": "Jobs by Estimator (Detail)",
        "estimator_summary": "Jobs by Estimator (Summary)",
        "export_payables": "Export Log - Payables",
        "export_payments": "Export Log - Payments",
        "export_receivables": "Export Log - Receivables",
        "exported_gsr_by_ro": "Exported Gross Sales - Excel",
        "exported_gsr_by_ro_labor": "Exported Gross Sales (Labor) - Excel",
        "gsr_by_atp": "",
        "gsr_by_ats": "Gross Sales by ATS",
        "gsr_by_category": "Gross Sales by Category",
        "gsr_by_csr": "Gross Sales by CSR",
        "gsr_by_delivery_date": "Gross Sales by Delivery Date",
        "gsr_by_estimator": "Gross Sales by Estimator",
        "gsr_by_exported_date": "Exported Gross Sales",
        "gsr_by_ins_co": "Gross Sales by Insurance Company",
        "gsr_by_make": "Gross Sales by Vehicle Make",
        "gsr_by_referral": "Gross Sales by Referral Source",
        "gsr_by_ro": "Gross Sales by RO",
        "gsr_labor_only": "Gross Sales - Labor Only",
        "hours_sold_detail_closed": "Hours Sold Detail - Closed",
        "hours_sold_detail_closed_csr": "Hours Sold Detail - Closed by CSR",
        "hours_sold_detail_closed_estimator": "Hours Sold Detail - Closed by Estimator",
        "hours_sold_detail_closed_ins_co": "Hours Sold Detail - Closed by Source",
        "hours_sold_detail_closed_status": "Hours Sold Detail - Closed by Status",
        "hours_sold_detail_open": "Hours Sold Detail - Open",
        "hours_sold_detail_open_csr": "Hours Sold Detail - Open by CSR",
        "hours_sold_detail_open_estimator": "Hours Sold Detail - Open by Estimator",
        "hours_sold_detail_open_ins_co": "Hours Sold Detail - Open by Source",
        "hours_sold_detail_open_status": "Hours Sold Detail - Open by Status",
        "hours_sold_summary_closed": "Hours Sold Summary - Closed",
        "hours_sold_summary_closed_csr": "Hours Sold Summary - Closed by CSR",
        "hours_sold_summary_closed_estimator": "Hours Sold Summary - Closed by Estimator",
        "hours_sold_summary_closed_ins_co": "Hours Sold Summary - Closed by Source",
        "hours_sold_summary_closed_status": "Hours Sold Summary - Closed by Status",
        "hours_sold_summary_open": "Hours Sold Summary - Open",
        "hours_sold_summary_open_csr": "Hours Sold Summary - Open CSR",
        "hours_sold_summary_open_estimator": "Hours Sold Summary - Open Estimator",
        "hours_sold_summary_open_ins_co": "Hours Sold Summary - Open by Source",
        "hours_sold_summary_open_status": "Hours Sold Summary - Open by Status",
        "job_costing_ro_csr": "Job Costing by CSR",
        "job_costing_ro_date_detail": "Job Costing by RO - Detail",
        "job_costing_ro_date_summary": "Job Costing by RO - Summary",
        "job_costing_ro_estimator": "Job Costing by Estimator",
        "job_costing_ro_ins_co": "Job Costing by RO Source",
        "job_lifecycle_date_detail": "Job Lifecycle by Date - Detail",
        "job_lifecycle_date_summary": "Job Lifecycle by Date - Summary",
        "jobs_completed_not_invoiced": "Jobs Completed not Invoiced",
        "jobs_invoiced_not_exported": "Jobs Invoiced not Exported",
        "jobs_reconcile": "Parts/Sublet/Labor Reconciliation",
        "jobs_scheduled_completion": "Jobs Scheduled Completion",
        "lag_time": "Lag Time",
        "load_level": "Load Level",
        "lost_sales": "Lost Sales",
        "open_orders": "Open Orders by Date",
        "open_orders_csr": "Open Orders by CSR",
        "open_orders_estimator": "Open Orders by Estimator",
        "open_orders_excel": "Open Orders - Excel",
        "open_orders_ins_co": "Open Orders by Insurance Company",
        "open_orders_referral": "Open Orders by Referral Source",
        "open_orders_specific_csr": "Open Orders filtered by CSR",
        "open_orders_status": "Open Orders by Status",
        "parts_backorder": "IOU Parts List",
        "parts_not_recieved": "Parts Not Received",
        "parts_not_recieved_vendor": "Parts Not Received by Vendor",
        "parts_received_not_scheduled": "Parts Received for Jobs Not Scheduled",
        "payments_by_date": "Payments by Date",
        "payments_by_date_excel": "Payments by Date - Excel",
        "payments_by_date_payment": "Payments by Date and Payment Type",
        "payments_by_date_type": "Payments by Date and Customer Type",
        "production_by_category": "Production by Category",
        "production_by_category_one": "Production filtered by Category",
        "production_by_csr": "Production by CSR",
        "production_by_csr_one": "Production filtered by CSR",
        "production_by_writer": "Production by Writer",
        "production_by_writer_one": "Production filtered by Writer",
        "production_by_last_name": "Production by Last Name",
        "production_by_repair_status": "Production by Status",
        "production_by_repair_status_one": "Production filtered by Status",
        "production_by_ro": "Production by RO",
        "production_by_target_date": "Production by Scheduled Completion",
        "production_by_technician": "Production by Technician",
        "production_by_technician_one": "Production filtered by Technician",
        "production_not_production_status": "Production not in Production Status",
        "production_over_time": "Production Level over Time",
        "psr_by_make": "Percent of Sales by Vehicle Make",
        "purchase_return_ratio_excel": "Purchase & Return Ratio - Excel",
        "purchase_return_ratio_grouped_by_vendor_detail": "Purchase & Return Ratio by Vendor (Detail)",
        "purchase_return_ratio_grouped_by_vendor_summary": "Purchase & Return Ratio by Vendor (Summary)",
        "purchases_by_cost_center_detail": "Purchases by Cost Center (Detail)",
        "purchases_by_cost_center_summary": "Purchases by Cost Center (Summary)",
        "purchases_by_date_excel": "Purchases by Date - Excel",
        "purchases_by_date_range_detail": "Purchases by Date - Detail",
        "purchases_by_date_range_summary": "Purchases by Date - Summary",
        "purchases_by_ro_detail_date": "Purchases by RO - Detail",
        "purchases_by_ro_summary_date": "Purchases by RO - Summary",
        "purchases_by_vendor_detailed_date_range": "Purchases By Vendor - Detailed",
        "purchases_by_vendor_summary_date_range": "Purchases by Vendor - Summary",
        "purchases_grouped_by_vendor_detailed": "Purchases Grouped by Vendor - Detailed",
        "purchases_grouped_by_vendor_summary": "Purchases Grouped by Vendor - Summary",
        "returns_grouped_by_vendor_detailed": "Returns Grouped by Vendor - Detailed",
        "returns_grouped_by_vendor_summary": "Returns Grouped by Vendor - Summary",
        "schedule": "Appointment Schedule",
        "scheduled_parts_list": "Parts for Jobs Scheduled In",
        "scoreboard_detail": "Scoreboard Detail",
        "scoreboard_summary": "Scoreboard Summary",
        "supplement_ratio_ins_co": "Supplement Ratio by Source",
        "tasks_date": "Tasks by Date",
        "tasks_date_employee": "Employee Tasks by Date",
        "thank_you_date": "Thank You Letters",
        "timetickets": "Time Tickets",
        "timetickets_employee": "Employee Time Tickets",
        "timetickets_summary": "Time Tickets Summary",
        "total_loss_jobs": "Jobs Marked as Total Loss",
        "unclaimed_hrs": "Unflagged Hours",
        "void_ros": "Void ROs",
        "work_in_progress_committed_labour": "Work in Progress - Committed Labor",
        "work_in_progress_jobs": "Work in Progress - Jobs",
        "work_in_progress_labour": "Work in Progress - Labor (Detail)",
        "work_in_progress_labour_summary": "Work in Progress - Labor (Summary)",
        "work_in_progress_payables": "Work in Progress - Payables (Detail)",
        "work_in_progress_payables_summary": "Work in Progress - Payables (Summary)"
      }
    },
    "schedule": {
      "labels": {
        "atssummary": "ATS Summary",
        "employeevacation": "Employee Vacations",
        "estimators": "Filter by Writer/Customer Rep.",
        "ins_co_nm_filter": "Filter by Insurance Company",
        "intake": "Intake Events",
        "manual": "Manual Events",
        "manualevent": "Add Manual Event"
      }
    },
    "scoreboard": {
      "actions": {
        "edit": "Edit"
      },
      "errors": {
        "adding": "Error adding Job to Scoreboard. {{message}}",
        "removing": "Error removing Job from Scoreboard. {{message}}",
        "updating": "Error updating Scoreboard. {{message}}"
      },
      "fields": {
        "bodyhrs": "Body Hours",
        "date": "Date",
        "painthrs": "Paint Hours"
      },
      "labels": {
        "allemployeetimetickets": "All Employee Time Tickets",
        "asoftodaytarget": "As of Today",
        "body": "Body",
        "bodyabbrev": "B",
        "bodycharttitle": "Body Targets vs Actual",
        "calendarperiod": "Periods based on calendar weeks/months.",
        "combinedcharttitle": "Combined Targets vs Actual",
        "dailyactual": "Actual (D)",
        "dailytarget": "Daily",
        "efficiencyoverperiod": "Efficiency over Selected Dates",
        "entries": "Scoreboard Entries",
        "jobs": "Jobs",
        "jobscompletednotinvoiced": "Completed Not Invoiced",
        "lastmonth": "Last Month",
        "lastweek": "Last Week",
        "monthlytarget": "Monthly",
        "priorweek": "Prior Week",
        "productivestatistics": "Productive Hours Statistics",
        "productivetimeticketsoverdate": "Productive Hours over Selected Dates",
        "refinish": "Refinish",
        "refinishabbrev": "R",
        "refinishcharttitle": "Refinish Targets vs Actual",
        "targets": "Targets",
        "thismonth": "This Month",
        "thisweek": "This Week",
        "timetickets": "Time Tickets",
        "timeticketsemployee": "Time Tickets by Employee",
        "todateactual": "Actual (MTD)",
        "total": "Total",
        "totalhrs": "Total Hours",
        "totaloverperiod": "Total over Selected Dates",
        "weeklyactual": "Actual (W)",
        "weeklytarget": "Weekly",
        "workingdays": "Working Days / Month"
      },
      "successes": {
        "added": "Job added to scoreboard.",
        "removed": "Job removed from scoreboard.",
        "updated": "Scoreboard updated."
      }
    },
    "settings": {
      "title": "Phone Number Opt-Out List"
    },
    "tasks": {
      "actions": {
        "edit": "Edit Task",
        "new": "New Task",
        "view": "View Task"
      },
      "buttons": {
        "allTasks": "All",
        "complete": "Toggle Complete",
        "create": "Create Task",
        "delete": "Toggle Delete",
        "edit": "Edit",
        "myTasks": "Mine",
        "refresh": "Refresh"
      },
      "date_presets": {
        "completion": "Completion",
        "day": "Day",
        "days": "Days",
        "delivery": "Delivery",
        "next_week": "Next Week",
        "one_month": "One Month",
        "three_months": "Three Months",
        "three_weeks": "Three Weeks",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "two_weeks": "Two Weeks"
      },
      "errors": {
        "load_failure": "Failed to load Tasks."
      },
      "failures": {
        "completed": "Failed to toggle Task completion.",
        "created": "Failed to create Task.",
        "deleted": "Failed to toggle Task deletion.",
        "updated": "Failed to update Task."
      },
      "fields": {
        "actions": "Actions",
        "assigned_to": "Assigned To",
        "bill": "Bill",
        "billid": "Bill",
        "completed": "Completed",
        "created_at": "Created At",
        "created_by": "Created By",
        "description": "Description",
        "due_date": "Due Date",
        "job": {
          "ro_number": "RO #"
        },
        "jobid": "Job",
        "jobline": "Job Line",
        "joblineid": "Job Line",
        "parts_order": "Parts Order",
        "partsorderid": "Parts Order",
        "priorities": {
          "high": "High",
          "low": "Low",
          "medium": "Medium"
        },
        "priority": "Priority",
        "related_items": "Related Items",
        "remind_at": "Remind At",
        "title": "Title"
      },
      "labels": {
        "due_today": "Today",
        "go_to_job": "Go to Job",
        "my_tasks_center": "Task Center",
        "no_due_date": "Incomplete",
        "no_tasks": "No Tasks Found",
        "overdue": "Overdue",
        "ro-number": "RO #{{ro_number}}",
        "upcoming": "Upcoming"
      },
      "placeholders": {
        "assigned_to": "Select an Employee",
        "billid": "Select a Bill",
        "description": "Enter a description",
        "jobid": "Select a Job",
        "joblineid": "Select a Job Line",
        "partsorderid": "Select a Parts Order"
      },
      "successes": {
        "completed": "Toggled Task completion successfully.",
        "created": "Task created successfully.",
        "deleted": "Toggled Task deletion successfully.",
        "updated": "Task updated successfully."
      },
      "titles": {
        "all_tasks": "All Tasks",
        "completed": "Completed Tasks",
        "deleted": "Deleted Tasks",
        "job_tasks": "Job Tasks",
        "mine": "My Tasks",
        "my_tasks": "My Tasks"
      },
      "validation": {
        "due_at_error_message": "The due date must be in the future!",
        "remind_at_error_message": "The reminder date and time must be at least 30 minutes in the future!"
      }
    },
    "tech": {
      "fields": {
        "employeeid": "Employee ID",
        "pin": "PIN"
      },
      "inactivity": {
        "logout_now": "Log out now",
        "message": "You will be logged out in {{seconds}} seconds due to inactivity.",
        "stay_signed_in": "Stay signed in",
        "title": "Are you still there?"
      },
      "labels": {
        "loggedin": "Logged in as {{name}}",
        "notloggedin": "Not logged in."
      }
    },
    "templates": {
      "errors": {
        "updating": "Error updating template {{error}}."
      },
      "successes": {
        "updated": "Template updated successfully."
      }
    },
    "timetickets": {
      "actions": {
        "claimtasks": "Flag Hours",
        "clockin": "Clock In",
        "clockout": "Clock Out",
        "commit": "Commit Tickets ({{count}})",
        "commitone": "Commit",
        "enter": "Enter New Time Ticket",
        "payall": "Pay All",
        "printemployee": "Print Time Tickets",
        "uncommit": "Uncommit"
      },
      "errors": {
        "clockingin": "Error while clocking in. {{message}}",
        "clockingout": "Error while clocking out. {{message}}",
        "creating": "Error creating time ticket. {{message}}",
        "deleting": "Error deleting time ticket. {{message}}",
        "noemployeeforuser": "Unable to use Shift Clock",
        "noemployeeforuser_sub": "An employee record has not been created for this user. Please create one before using the shift clock. ",
        "notickets": "Unassigned Hours found and No time tickets to post.",
        "payall": "Error flagging hours. {{error}}",
        "shiftalreadyclockedon": "You are already clocked onto a shift. Unable to create shift entry."
      },
      "fields": {
        "actualhrs": "Actual Hours",
        "amount": "Amount",
        "ciecacode": "CIECA Code",
        "clockhours": "Clock Hours",
        "clockoff": "Clock Off",
        "clockon": "Clocked In",
        "committed": "Committed",
        "committed_at": "Committed At",
        "cost_center": "Cost Center",
        "created_by": "Created By",
        "date": "Ticket Date",
        "efficiency": "Efficiency",
        "employee": "Employee",
        "employee_team": "Employee Team",
        "flat_rate": "Flat Rate?",
        "memo": "Memo",
        "not_committed": "Not Committed",
        "pay": "Pay",
        "payout_method": "Payout Method",
        "productivehrs": "Productive Hours",
        "rate": "Rate",
        "ro_number": "Job to Post Against",
        "task_name": "Task"
      },
      "labels": {
        "alreadyclockedon": "You are already clocked in to the following Job(s):",
        "ambreak": "AM Break",
        "amshift": "AM Shift",
        "claimtaskpreview": "Flagged Hours  Preview",
        "clockhours": "Shift Clock Hours Summary",
        "clockintojob": "Clock In to Job",
        "deleteconfirm": "Are you sure you want to delete this time ticket? This cannot be undone.",
        "edit": "Edit Time Ticket",
        "efficiency": "Efficiency",
        "flat_rate": "Flat Rate",
        "jobhours": "Job Related Time Tickets Summary",
        "lunch": "Lunch",
        "new": "New Time Ticket",
        "payout_methods": {
          "commission": "Commission",
          "hourly": "Hourly"
        },
        "payrollclaimedtasks": "These time tickets will be automatically entered to the system as a part of claiming this task. These numbers are calculated using the jobs assigned lines. If lines are unassigned, they will be excluded from created tickets.",
        "pmbreak": "PM Break",
        "pmshift": "PM Shift",
        "selectTicketDate": "Select a Ticket Date",
        "shift": "Shift",
        "shiftalreadyclockedon": "Active Shift Time Tickets",
        "straight_time": "Straight Time",
        "task": "Task",
        "timetickets": "Time Tickets",
        "unassigned": "Unassigned",
        "zeroactualnegativeprod": "Actual hours must be 0 if entering negative productive hours."
      },
      "successes": {
        "clockedin": "Clocked in successfully.",
        "clockedout": "Clocked out successfully.",
        "committed": "Time Tickets Committed Successfully",
        "created": "Time ticket entered successfully.",
        "deleted": "Time ticket deleted successfully.",
        "payall": "All hours paid out successfully."
      },
      "validation": {
        "clockoffmustbeafterclockon": "Clock off time must be the same or after clock in time.",
        "clockoffwithoutclockon": "Clock off time cannot be set without a clock in time.",
        "hoursenteredmorethanavailable": "The number of hours entered is more than what is available for this cost center.",
        "unassignedlines": "There are currently {{unassignedHours}} hours of repair lines that are unassigned. These hours are not including in the above calculations and must be paid manually."
      }
    },
    "titles": {
      "accounting-payables": "Payables | {{app}}",
      "accounting-payments": "Payments | {{app}}",
      "accounting-receivables": "Receivables | {{app}}",
      "all_tasks": "All Tasks | {{app}}",
      "app": "",
      "bc": {
        "accounting-payables": "Payables",
        "accounting-payments": "Payments",
        "accounting-receivables": "Receivables",
        "all_tasks": "All Tasks",
        "availablejobs": "Available Jobs",
        "bills-list": "Bills",
        "contracts": "Contracts",
        "contracts-create": "New Contract",
        "contracts-detail": "Contract #{{number}}",
        "courtesycars": "Courtesy Cars",
        "courtesycars-detail": "Courtesy Car {{number}}",
        "courtesycars-new": "New Courtesy Car",
        "dashboard": "Dashboard",
        "dms": "DMS Export",
        "export-logs": "Export Logs",
        "feature-request": "Feature Request",
        "inventory": "Inventory",
        "jobs": "Jobs",
        "jobs-active": "Active Jobs",
        "jobs-admin": "Admin",
        "jobs-all": "All Jobs",
        "jobs-checklist": "Checklist",
        "jobs-close": "Close Job",
        "jobs-deliver": "Deliver Job",
        "jobs-detail": "Job {{number}}",
        "jobs-intake": "Intake",
        "jobs-new": "Create a New Job",
        "jobs-ready": "Ready Jobs",
        "my_tasks": "My Tasks",
        "owner-detail": "{{name}}",
        "owners": "Owners",
        "parts": "Parts",
        "parts-queue": "Parts Queue",
        "parts_settings": "Settings",
        "payments-all": "All Payments",
        "phonebook": "Phonebook",
        "productionboard": "Production Board - Visual",
        "productionlist": "Production Board - List",
        "profile": "My Profile",
        "schedule": "Schedule",
        "scoreboard": "Scoreboard",
        "shop": "Manage my Shop ({{shopname}})",
        "shop-csi": "CSI Responses",
        "shop-templates": "Shop Templates",
        "shop-vendors": "Vendors",
        "simplified-parts-jobs": "Jobs",
        "tasks": "Tasks",
        "temporarydocs": "Temporary Documents",
        "timetickets": "Time Tickets",
        "ttapprovals": "Time Ticket Approvals",
        "vehicle-details": "Vehicle: {{vehicle}}",
        "vehicles": "Vehicles"
      },
      "bills-list": "Bills | {{app}}",
      "contracts": "Courtesy Car Contracts | {{app}}",
      "contracts-create": "New Contract | {{app}}",
      "contracts-detail": "Contract {{id}} | {{app}}",
      "courtesycars": "Courtesy Cars | {{app}}",
      "courtesycars-create": "New Courtesy Car | {{app}}",
      "courtesycars-detail": "Courtesy Car {{id}} | {{app}}",
      "dashboard": "Dashboard | {{app}}",
      "dms": "DMS Export | {{app}}",
      "export-logs": "Export Logs | {{app}}",
      "feature-request": "Feature Request | {{app}}",
      "imexonline": "ImEX Online",
      "inventory": "Inventory | {{app}}",
      "jobs": "Active Jobs | {{app}}",
      "jobs-admin": "Job {{ro_number}} - Admin | {{app}}",
      "jobs-all": "All Jobs | {{app}}",
      "jobs-checklist": "Job Checklist | {{app}}",
      "jobs-close": "Close Job {{number}} | {{app}}",
      "jobs-create": "Create a New Job | {{app}}",
      "jobs-deliver": "Deliver Job | {{app}}",
      "jobs-intake": "Intake | {{app}}",
      "jobsavailable": "Available Jobs | {{app}}",
      "jobsdetail": "Job {{ro_number}} | {{app}}",
      "jobsdocuments": "Job Documents {{ro_number}} | {{app}}",
      "manageroot": "Home | {{app}}",
      "my_tasks": "My Tasks | {{app}}",
      "owners": "All Owners | {{app}}",
      "owners-detail": "{{name}} | {{app}}",
      "parts": "",
      "parts-queue": "Parts Queue | {{app}}",
      "parts_settings": "Parts Management Settings | {{app}}",
      "payments-all": "Payments | {{app}}",
      "phonebook": "Phonebook | {{app}}",
      "productionboard": "Production Board - Visual | {{app}}",
      "productionlist": "Production Board - List | {{app}}",
      "profile": "My Profile | {{app}}",
      "readyjobs": "Ready Jobs | {{app}}",
      "resetpassword": "Reset Password",
      "resetpasswordvalidate": "Enter New Password",
      "romeonline": "Rome Online",
      "schedule": "Schedule | {{app}}",
      "scoreboard": "Scoreboard |  {{app}}",
      "shop": "My Shop | {{app}}",
      "shop-csi": "CSI Responses | {{app}}",
      "shop-templates": "Shop Templates | {{app}}",
      "shop_vendors": "Vendors | {{app}}",
      "simplified-parts-jobs": "Parts Management | {{app}}",
      "tasks": "Tasks",
      "techconsole": "Technician Console | {{app}}",
      "techjobclock": "Technician Job Clock | {{app}}",
      "techjoblookup": "Technician Job Lookup | {{app}}",
      "techshiftclock": "Technician Shift Clock | {{app}}",
      "temporarydocs": "Temporary Documents | {{app}}",
      "timetickets": "Time Tickets | {{app}}",
      "ttapprovals": "Time Ticket Approvals | {{app}}",
      "vehicledetail": "Vehicle Details {{vehicle}} | {{app}}",
      "vehicles": "All Vehicles | {{app}}"
    },
    "trello": {
      "labels": {
        "add_card": "Add Card",
        "add_lane": "Add Lane",
        "cancel": "Cancel",
        "delete_lane": "Delete Lane",
        "description": "Description",
        "label": "Label",
        "lane_actions": "Lane Actions",
        "title": "Title"
      }
    },
    "tt_approvals": {
      "actions": {
        "approveselected": "Approve Selected"
      },
      "labels": {
        "approval_queue_in_use": "Time tickets will be added to the approval queue.",
        "calculate": "Calculate"
      }
    },
    "upsell": {
      "cta": {
        "learnmore": "Learn More"
      },
      "messages": {
        "accounting": {
          "payables": {
            "subtitle": "Effortlessly send your bills and payables to QuickBooks Online or QuickBooks Desktop eliminating the need for duplicate data entry.",
            "title": "Eliminate double data entry"
          },
          "payments": {
            "subtitle": "Effortlessly send your bills and payables to QuickBooks Online or QuickBooks Desktop eliminating the need for duplicate data entry.",
            "title": "Eliminate double data entry"
          },
          "receivables": {
            "subtitle": "Effortlessly send your invoices to QuickBooks Online or QuickBooks Desktop eliminating the need for duplicate data entry.",
            "title": "Eliminate double data entry"
          }
        },
        "audit": {
          "general": {
            "subtitle": "Know exactly what happened and when through the entire repair process.",
            "title": "Comprehensive Audit Trails"
          }
        },
        "bills": {
          "autoreconcile": {
            "subtitle": "Let your management system do the tedious work - take advantage of automatic job reconciliation today.",
            "title": "Did you account for every invoice?"
          },
          "general": {
            "subtitle": "Our Bills module allows you to precisely account for every penny on the repair order to ensure you maximize your bottom line.",
            "title": "Boost your profits by taking control of costs!"
          }
        },
        "checklist": {
          "general": {
            "subtitle": "Standardize your intake and delivery with digitized checklists and SOPs.",
            "title": "Done right, the first time."
          }
        },
        "courtesycars": {
          "general": {
            "subtitle": "Keep track of vehicles and contracts for your courtesy cars, all seamlessly synchronized with your Jobs.",
            "title": "Manage your fleet with ease"
          }
        },
        "csi": {
          "general": {
            "subtitle": "With our integrated CSI module, send follow up surveys to your customers to see how well you did.",
            "title": "See what your customers have to say"
          }
        },
        "dashboard": {
          "general": {
            "subtitle": "Make data based decisions and take control of your business using our real-time dashboard.",
            "title": "Realtime Insight & Analytics"
          }
        },
        "lifecycle": {
          "general": {
            "subtitle": "Job life cycles tell you exactly how long the job stayed in each stage of the repair process to identify bottle necks and inefficiencies.",
            "title": "Are your repair KPIs suffering?"
          }
        },
        "media": {
          "general": {
            "subtitle": "Store your vehicle repair documentation, invoices, and related documents digitally to access them anywhere, any time.",
            "title": "Go paperless."
          },
          "mobile": {
            "subtitle": "Use our mobile app to  attach  images from your device to the job, increasing your efficiency.",
            "title": "Accelerate repair documentation with Mobile"
          }
        },
        "payments": {
          "general": {
            "subtitle": "Manage outstanding balances and collect payments by credit card from your customers.",
            "title": "Integrated Accounts Receivable & Payments"
          }
        },
        "scoreboard": {
          "general": {
            "subtitle": "Understand hours produced and sold to facilitate employee incentive programs.",
            "title": "Give credit where credit is due"
          }
        },
        "smartscheduling": {
          "datepicker": {
            "subtitle": "Smart Scsheduling gives you the best dates for a vehicle to come in based on your current and predicted production load.",
            "title": "When's the best time for this job to arrive?"
          },
          "general": {
            "subtitle": "Know exactly how busy you will be tomorrow, the day after, or next week to know exactly when to schedule your next repair.",
            "title": "Forecast your production with Smart Scheduling"
          },
          "hrsdelta": {
            "subtitle": "Understand changes to your Work in Progress and production load instantly.",
            "title": "Cars come and cars go."
          }
        },
        "techconsole": {
          "general": {
            "subtitle": "The technician's console allows technicians to see job information, media, documents and keep track of their time.",
            "title": "Empower your Technicians"
          }
        },
        "timetickets": {
          "allocations": {
            "subtitle": "Ensure your technicians are paid out exactly what they are owed - not a penny less, not a penny more.",
            "title": "Technician Payments Done Just Right"
          },
          "general": {
            "subtitle": "Track your technicians time with precision, giving you insight to repair progress and labor efficiency.",
            "title": "Who did what and for how long?"
          }
        },
        "visualboard": {
          "general": {
            "subtitle": "The Visual Production Board makes it easier than ever before to manage your work in progress.",
            "title": "A whole new kind of production board"
          }
        }
      }
    },
    "user": {
      "actions": {
        "changepassword": "Change Password",
        "dark_theme": "Switch to Dark Theme",
        "light_theme": "Switch to Light Theme",
        "signout": "Sign Out",
        "updateprofile": "Update Profile"
      },
      "errors": {
        "updating": "Error updating user or association {{message}}"
      },
      "fields": {
        "authlevel": "Authorization Level",
        "displayname": "Display Name",
        "email": "Email",
        "photourl": "Avatar URL"
      },
      "labels": {
        "actions": "Actions",
        "changepassword": "Change Password",
        "notification_sound_disabled": "Notification sound disabled",
        "notification_sound_enabled": "Notification sound enabled",
        "notification_sound_help": "Toggle the ding for incoming chat messages.",
        "notification_sound_off": "Sound is OFF",
        "notification_sound_on": "Sound is ON",
        "play_sound_for_new_messages": "Play a sound for new messages",
        "profileinfo": "Profile Info",
        "user_settings": "User Settings"
      },
      "successess": {
        "passwordchanged": "Password changed successfully. "
      }
    },
    "users": {
      "errors": {
        "signinerror": {
          "auth/invalid-email": "A user with this email does not exist.",
          "auth/user-disabled": "User account disabled. ",
          "auth/user-not-found": "A user with this email does not exist.",
          "auth/wrong-password": "The email and password combination you provided is incorrect."
        }
      }
    },
    "vehicles": {
      "errors": {
        "deleting": "Error deleting vehicle. {{error}}.",
        "noaccess": "The vehicle does not exist or you do not have access to it.",
        "selectexistingornew": "Select an existing vehicle record or create a new one. ",
        "validation": "Please ensure all fields are entered correctly.",
        "validationtitle": "Validation Error"
      },
      "fields": {
        "description": "Vehicle Description",
        "notes": "Vehicle Notes",
        "plate_no": "License Plate",
        "plate_st": "Plate Jurisdiction",
        "trim_color": "Trim Color",
        "v_bstyle": "Body Style",
        "v_color": "Color",
        "v_cond": "Condition",
        "v_engine": "Engine",
        "v_make_desc": "Make",
        "v_makecode": "Make Code",
        "v_mldgcode": "Molding Code",
        "v_model_desc": "Model",
        "v_model_yr": "Year",
        "v_options": "Options",
        "v_paint_codes": "Paint Codes {{number}}",
        "v_prod_dt": "Production Date",
        "v_stage": "Stage",
        "v_tone": "Tone",
        "v_trimcode": "Trim Code",
        "v_type": "Type",
        "v_vin": "V.I.N."
      },
      "forms": {
        "detail": "Vehicle Details",
        "misc": "Miscellaneous",
        "registration": "Registration"
      },
      "labels": {
        "deleteconfirm": "Are you sure you want to delete this vehicle? This cannot be undone.",
        "fromvehicle": "Historical Vehicle Record",
        "novehinfo": "No Vehicle Information",
        "relatedjobs": "Related Jobs",
        "updatevehicle": "Update Vehicle Information"
      },
      "successes": {
        "delete": "Vehicle deleted successfully.",
        "save": "Vehicle saved successfully."
      }
    },
    "vendors": {
      "actions": {
        "addtophonebook": "Add to Phonebook",
        "new": "New Vendor",
        "newpreferredmake": "New Preferred Make"
      },
      "errors": {
        "deleting": "Error encountered while deleting vendor. ",
        "saving": "Error encountered while saving vendor. "
      },
      "fields": {
        "active": "Active",
        "am": "Aftermarket",
        "city": "City",
        "cost_center": "Cost Center",
        "country": "Country",
        "discount": "Discount (as decimal)",
        "display_name": "Display Name",
        "dmsid": "DMS ID",
        "due_date": "Payment Due Date",
        "email": "Contact Email",
        "favorite": "Favorite?",
        "lkq": "LKQ",
        "make": "Make",
        "name": "Vendor Name",
        "oem": "OEM",
        "phone": "Phone",
        "prompt_discount": "Prompt Discount %",
        "state": "Province/State",
        "street1": "Street",
        "street2": "Address 2",
        "tags": "Tags",
        "taxid": "Tax ID",
        "terms": "Payment Terms",
        "zip": "Zip/Postal Code"
      },
      "labels": {
        "inputprefixes": {
          "days": "# Of Days",
          "discount": "%"
        },
        "noneselected": "No vendor is selected.",
        "preferredmakes": "Preferred Makes for Vendor",
        "search": "Type a Vendor's Name",
        "sections": {
          "address": "Address",
          "billing": "Billing Defaults",
          "contact": "Contact",
          "location": "Location",
          "tags": "Tags",
          "vendor": "Vendor Details"
        },
        "vendor": "Vendor"
      },
      "successes": {
        "deleted": "Vendor deleted successfully. ",
        "saved": "Vendor saved successfully."
      },
      "validation": {
        "unique_vendor_name": "You must enter a unique vendor name."
      }
    }
  }
}
